import React, { Component } from 'react'
import { Grid, Button, Icon, Loader, Radio } from 'semantic-ui-react'
import InputField from '../../formComponents/inputField'
import { DropDown } from '../../formComponents/dropDown'
import * as actionCreators from '../../actions'
import { getTargetPGAForm } from '../../api/getEntrySummaryData'
import DutyItems from './DutyItems'
import { connect } from 'react-redux'
import { createMerchandiseDutyItem } from '../../api/createItem'
import SelecTextField from '../../formComponents/selectTextField'
import CustomCheckbox from '../../formComponents/checkBox'
import { displayMasterItem, displayDropDownItem } from '../util'
import {pgaHumanNames, pgaTypes} from '../pga/constantsPGA';
import PGAItems from '../pga/PGAItems'
import Warning from '../Warnings/Warning'
import _, { get, trim } from 'lodash'
import store from '../../store'
import PopUpIcon from '../../formComponents/PopUpIcon'
import AVCVDSection from '../../formComponents/avcvdSection'
import { DoMFields } from '../../util/supportedFields/descriptionOfMerchandise'
import { HttpClient } from './../../../apiCalls/httpClient'
import PscLineItemReason from '../lineReason'
import {
  fetchSelectedReasonCodes,
  resetDutyItemFieldsInNonCommodity,
} from '../../util'
import {
  savePGAItemField,
  savemanufacturerIdforManufacturer,
  associateManufacturerIdtoLineItem,
} from '../../api/setFormData'
import { saveNewManufacturer } from '../../api/setFormData'
import ManageProductHistory from '../../../components/AccountMenu/components/productLineHistory/History'
import { changeCountryOfOrigin } from '../../util'
import {DECLARATION_OPTIONS, russiaMetaData} from "../util/constants";

import { confirmAlert } from 'react-confirm-alert' // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { pgaLabels } from '../../text/pga'
import { hasanyvaluesAdcvd, isWarehouseEntry, propsAreEqual_NoRerenderNeeded } from '../../reducer/util'
import UpdateTariffs from '../UpdateTariffs'
import RefreshPart from './RefreshPart'
import AdditionalDeclarations from './AdditionalDeclarations'
import { addAdditionalDeclarations, deleteAdditionalDeclarations } from '../../actions/DescriptionOfMerchandiseActions'

class MerchandiseLineItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isDeleting: false,
      isDutyAdding: false,
      addingExclusions: [],
      formInfo: {},
      mystate: store.getState(),
      brokerId: props.brokerId,
      midList_bv: [],
      showMidList: false,
      showLineItem: false, //this.props.totalLineItems <= 5 ? true :false,
      showSkuList: false,
      skuList_yh: [],
      selectedHistoryItem: 0,
      hasDoneProductHistorySearch: false,
      showHistoryAnimation: 0,
      manualAdcvdButtonClicked: false,
      setIrTaxFields: null
    }
    for (let key in DoMFields) {
      DoMFields[key].errors = []
      DoMFields[key].valid = []
    }
    this.addErrorClass.bind(this)
    this.removeErrorClass.bind(this)
    this.validateField.bind(this)
  }

  componentWillMount() {
    if (this.props.pscData) {
      this.selectedReasons = this.props.pscData?.lineCodes
        ? fetchSelectedReasonCodes(
            this.props?.pscData?.lineCodes,
            this.props.merchandiseId
          )
        : [];
   
 
      const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
      this.enableDisableFrom(isTheOwningBroker && this.selectedReasons.length > 0  && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY'))
    }
  }

  componentWillReceiveProps() {
    if (this.props.pscData?.pscShipmentId) {
      this.selectedReasons = this.props.pscData.lineCodes
        ? fetchSelectedReasonCodes(
            this.props.pscData.lineCodes,
            this.props.merchandiseId
          )
        : [];
      const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
      this.enableDisableFrom(isTheOwningBroker && 
        this.selectedReasons.length > 0 &&
          (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||
            get(this.props, 'pscState.value.state') === 'STATE_PSC_READY')
      )
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.expandAllLines !== this.props.expandAllLines) {
      this.setState({ showLineItem: this.props.expandAllLines }, () =>
        this.props.hideExpandLoader(this.props.invoiceItemIndex)
      )
    }
    const hsDataDtl = this.props.hsDataDtl || {};
    const irTaxFields = hsDataDtl.userfeeDetails
    const htsNo = hsDataDtl.htsNo
    let newLastUserFees = (prevProps?.userFees?.length||0) + "_" +(this.props?.userFees?.length||0)
    if (prevProps?.userFees?.length != this.props?.userFees?.length && newLastUserFees != this.state.newLastUserFees) {
      this.setState({
        lastUserFees: Date.now(),
        newLastUserFees: newLastUserFees
      })
    }

    if(irTaxFields && irTaxFields.dutyType && this.state.setIrTaxFields != htsNo && prevProps?.internalRevenueAccountingClassCodesList.map(IRCodes => IRCodes.value + "_FEE").includes(irTaxFields.dutyType)){
      const value = irTaxFields.dutyType.slice(0, -4)
      this.setState({
        isIRTaxAdding: true,
        setIrTaxFields: htsNo,
        cbmaDeclaration: ["DISTILLED_SPIRITS", "WINES", "OTHER"].includes(value) ? true : false
      })
      let {
        lineItemIndex,
        invoiceItemIndex
      } = this.props
      this.props.updateMerchDutyItemObject(
        lineItemIndex,
        invoiceItemIndex,
        0, //duty index
        'irInfo',
        'IRTaxClass',
        value
      )
      this.props.saveMerchDutyItem(
        lineItemIndex,
        invoiceItemIndex,
        0,
        'irInfo'
      )
    }
  }

  // shouldComponentUpdate(nextProps, nextState){
  //   return (!_.isEqual(nextProps, this.props)) || (this.props.expandAllLines!==nextProps.expandAllLines) ||
  //   (nextState.showLineItem!==this.state.showLineItem)
  //   || nextState.showSkuList
  // }

  HTScodetoPeriods = (htsss) => {
    function insert(str, index, value) {
      return str.substr(0, index) + value + str.substr(index)
    }
    if (!htsss) return ''
    if (htsss.length == 10) {
      htsss = insert(htsss, 8, '.')
      htsss = insert(htsss, 6, '.')
      htsss = insert(htsss, 4, '.')
    }
    return htsss
  }

  callSEARCH_PRODUCT_LINE_HISTORY_api = (
    commercialDescription,
    productTag,
    htsus,
    countryOfOrigin,
    manufacturerId
  ) => {
    const data = {
      eventMessage: {
        customerId: window.shipmentId.split('-')[1], //FIX!?!?!??!
        filerCode:
          this.props.EntryTypeInfo && this.props.EntryTypeInfo?.filerCode,
        country: 'US',
        productDescription: commercialDescription,
        productTag: productTag,
        HTS: htsus,
        countryOrigin: countryOfOrigin,
        manufacturerId: manufacturerId,
      },
      eventTime: Date.now(),
      eventType: 'SEARCH_PRODUCT_LINE_HISTORY',
      responseTopic: '',
    }
    return HttpClient.custom({
      data,
    }).then((response) => {
      console.log('response: ', response)
      this.setState({
        skuList_yh: _.get(
          response,
          'data.eventMessage.productLineHistoryRecord',
          []
        ),
      })
    })
  }

  getAdvancedDetailsGET_PRODUCT_LINE_HISTORY_DETAILS = (
    productLineId,
    merchandiseId,
    lineItemIndex,
    invoiceItemIndex,
    invoiceId
  ) => {
    let {
      updateMerchDutyItemFeild,
      updateMerchDutyItemObject,
      saveMerchDutyItem,
      handleDutyItemContextSwitch,
      setHSDTL,
      allDuties,
      addUserFeeByList,
      updateMerchLineItemFeild,
      saveDescriptionOfMerchandiseLine,
      updateAVCDVDField,
      itDate,
      entryDate,
    } = this.props
    const data = {
      eventMessage: {
        customerId: window.shipmentId.split('-')[1], //FIX!?!?!??!
        productLineId: productLineId,
        countryOfRequest: 'US',
      },
      eventType: 'GET_PRODUCT_LINE_HISTORY_DETAILS',
      eventTime: Date.now(),
      responseTopic: '',
    }
    this.setState({doingHistoryStuff:true})
    return HttpClient.custom({
      data,
    }).then((response) => {
      let tradeProgram = _.get(
        response,
        'data.eventMessage.productLineHistoryRecord[0].tradeProgramClaimCode',
        ''
      )
      if (tradeProgram) {
        updateMerchLineItemFeild(
          lineItemIndex,
          invoiceItemIndex,
          'productClaimCode',
          tradeProgram
        )
        saveDescriptionOfMerchandiseLine(
          lineItemIndex,
          invoiceItemIndex,
          'productClaimCode'
        )
      }
      //product history details
      //sort of copied from DutyItem... HTS #
      let myarrayofdutyHistories = _.get(
        response,
        'data.eventMessage.productLineHistoryRecord[0].merchandiseDuties.duties',
        []
      )
      myarrayofdutyHistories.forEach((oneduty, myindexofduty) => {
        setTimeout(() => {
          //ADCVD
          if (oneduty.adcvd) {
            updateAVCDVDField(
              'adcvdNotApplicable',
              oneduty.adcvd.adcvdNotApplicable,
              true,
              lineItemIndex,
              invoiceItemIndex,
              this.props.shipmentId,
              merchandiseId
            )
            if (oneduty.adcvd.ad && oneduty.adcvd.ad.caseNo) {
              updateAVCDVDField(
                'ad.caseNo',
                oneduty.adcvd.ad.caseNo,
                true,
                lineItemIndex,
                invoiceItemIndex,
                this.props.shipmentId,
                merchandiseId
              )
            }
            if (oneduty.adcvd.cvd && oneduty.adcvd.cvd.caseNo) {
              updateAVCDVDField(
                'cvd.caseNo',
                oneduty.adcvd.cvd.caseNo,
                true,
                lineItemIndex,
                invoiceItemIndex,
                this.props.shipmentId,
                merchandiseId
              )
            }
          }
        }, 2000)

        //net qty-hts unit set from history
        if (_.get(oneduty, 'manifestQuantity.units', '')) {
          updateMerchDutyItemObject(
            lineItemIndex,
            invoiceItemIndex,
            myindexofduty,
            'manifestQuantity',
            'units',
            _.get(oneduty, 'manifestQuantity.units', '')
          )
          saveMerchDutyItem(
            lineItemIndex,
            invoiceItemIndex,
            myindexofduty,
            'manifestQuantity'
          )
        }

        if (myindexofduty == 0) {
          addUserFeeByList(
            lineItemIndex,
            invoiceItemIndex,
            0,
            _.get(oneduty, 'additionalDuties.userFees', [])
          )
          return //leave above foreach
        }
        if (allDuties.length <= myindexofduty) {
          //add the duty line if we're too short!
          createMerchandiseDutyItem(
            invoiceItemIndex,
            invoiceId,
            merchandiseId,
            lineItemIndex,
            function () {}
          )
        } else {
          let newhtsnoncommodity =
            oneduty.htsus &&
            (oneduty.htsus.indexOf('98') == 0 ||
              oneduty.htsus.indexOf('99') == 0)
          if (newhtsnoncommodity) {
            //99/98 chapter reset all this unused stuff// remember this is copied
            resetDutyItemFieldsInNonCommodity(
              updateMerchDutyItemObject,
              lineItemIndex,
              invoiceItemIndex,
              myindexofduty,
              saveMerchDutyItem,
              updateMerchDutyItemFeild
            )
          }
        }

        //hts stuff!
        setTimeout(() => {
          if (oneduty.htsus) {
            updateMerchDutyItemFeild(
              invoiceItemIndex,
              lineItemIndex,
              myindexofduty,
              'htsus',
              this.HTScodetoPeriods(oneduty.htsus)
            )
            saveMerchDutyItem(
              lineItemIndex,
              invoiceItemIndex,
              myindexofduty,
              'htsus'
            )

            setHSDTL(
              itDate,
              this.props.EntryTypeInfo,
              this.HTScodetoPeriods(oneduty.htsus),
              invoiceItemIndex,
              lineItemIndex,
              myindexofduty,
              2, //not a commodity
              false
            )
            handleDutyItemContextSwitch(
              lineItemIndex,
              invoiceItemIndex,
              myindexofduty
            )
            saveMerchDutyItem(
              lineItemIndex,
              invoiceItemIndex,
              myindexofduty,
              'htsus'
            )
            setTimeout(() => {
              if (oneduty.htsus.indexOf('98') == 0) {
                let overridecheckboxlist = document.querySelectorAll(
                  `.dutyxClass${merchandiseId}--dutyoverridecheckbox:not(:checked)`
                )
                for (let checkbox of overridecheckboxlist) {
                  checkbox.click()
                }
              }
            }, 1500) //wait for the re-render!
          }
        }, 1000) //wait for the re-render!
      })

      //License/Permit stuff!
      let basehistoryrecord = _.get(
        response,
        'data.eventMessage.productLineHistoryRecord[0]',
        {}
      )

      if (basehistoryrecord.permitTypeCode) {
        updateMerchLineItemFeild(
          lineItemIndex,
          invoiceItemIndex,
          'permitTypeCode',
          basehistoryrecord.permitTypeCode
        )
        saveDescriptionOfMerchandiseLine(
          lineItemIndex,
          invoiceItemIndex,
          'permitTypeCode',
          basehistoryrecord.permitTypeCode
        )
        updateMerchLineItemFeild(
          lineItemIndex,
          invoiceItemIndex,
          'permitNumber',
          basehistoryrecord.permitNumber
        )
        saveDescriptionOfMerchandiseLine(
          lineItemIndex,
          invoiceItemIndex,
          'permitNumber'
        )
      }
      //END License/Permit stuff!

      // permitNumber: "76586751"
      // permitTypeCode: 12
      //   referenceMerchandiseId: "DKU3JOjSQx8EFBgjTQbo"
      //   referenceShipmentId: "KX-I2I1-39"

      //Select and populate all old pgas
      let myarrayofpgadata = _.get(
        response,
        'data.eventMessage.productLineHistoryRecord[0].pgaData.pgaActData',
        []
      )
      // let pgaIndex = 0
      // for (let onepgaact of myarrayofpgadata) {
      //   selectPGARedux(
      //     lineItemIndex,
      //     invoiceItemIndex,
      //     merchandiseId,
      //     onepgaact.pgaType,
      //     pgaIndex,
      //     []
      //   )
      //   pgaIndex++
      // }
      //click the pga titles to preload them, should be obsolete as we load in the getTargetPGAForm
      // setTimeout(() => {
      //   for (let timer of [400, 1800]) {
      //     let innertimer = 0
      //     for (let onetitle of document.querySelectorAll(
      //       '.lineitemindexzz' + lineItemIndex + ' .pga-container .title'
      //     )) {
      //       //TODO: Make this redux
      //       setTimeout(() => {
      //         onetitle.click()
      //       }, timer + innertimer)
      //       innertimer += 100
      //     }
      //   }
      // }, 1250)
      //save the old pga data
      //pga stuff!!
      let usedFlagsXX = [];
      if(!isWarehouseEntry(this.props.EntryTypeInfo)){
        setTimeout(async () => {
          for (let onepgaact of myarrayofpgadata) {
            let currentpgaitems = onepgaact.PGAItems
            currentpgaitems = currentpgaitems.filter(
              (onePgaItem) => onePgaItem && ![
                'quantity',
              "containerNum"].includes(onePgaItem.PGAId) &&
              !(onepgaact.pgaType == "AMS_OR2" && ["lcpoNumber"].includes(onePgaItem.PGAId))
            )
            for(let onepgaItem of currentpgaitems){
              if(onepgaItem.key == 'dateOfSign'){
                onepgaItem.value = Date.now()+"";
              }
            }
            let existingpgaFlags = _.cloneDeep(this.props.pgaFlagInfos)||[]
            // savePGAItemField(null, currentpgaitems, merchandiseId, onepgaact.pgaType)

            let matchingFlag = existingpgaFlags.find(aaaa=>aaaa.pgaType == onepgaact.pgaType && !usedFlagsXX.includes(aaaa.pgaGuid));
            let newPgaGuid = null;//new pga
            if(matchingFlag){
              newPgaGuid = matchingFlag.pgaGuid;//not new pga, overwrite old one
              existingpgaFlags = existingpgaFlags.filter(aaaa=>aaaa.pgaGuid !== newPgaGuid);
            }
            let responseList = [];
            let responsexx = await getTargetPGAForm(onepgaact.pgaType, newPgaGuid, merchandiseId, {isManuallyAddedPga:true})
            let newPGAList = JSON.parse(JSON.stringify(this.props.pgaFlagInfos)) || []
            let newPgaFlag = {}
            let keys = ["ediSeqOrder", "isManuallyAddedPga", "lastModifiedTimeInMs", "pgaGuid", "pgaType", "createdTimeInMs", "formType"];
            let worked = false;
            if (newPGAList && newPGAList.length) {
              for (let key2 of Object.keys(newPGAList[0] || {})) {
                newPgaFlag[key2] = responsexx.data.eventMessage[key2];
              }
            }
            for (let key of keys) {
              newPgaFlag[key] = responsexx.data.eventMessage[key];
              worked = newPgaFlag[key];
            }
            if (!worked) {
              window.alert("PGA ADDITION FAILED: " + onepgaact.pgaType)
              return;
            }
            let res = response.data?.eventMessage || response?.eventMessage
            newPgaFlag["disclaimCode"]= res?.productLineHistoryRecord?.[0]?.pgaData?.pgaActData?.find((item)=>item.pgaType===newPgaFlag?.formType)?.PGAItems.find((it)=>it.key==="disclaimCode")?.value
            newPgaFlag["disclaimFlag"]= res?.productLineHistoryRecord?.[0]?.pgaData?.pgaActData?.find((item)=>item.pgaType===newPgaFlag?.formType)?.PGAItems.find((it)=>it.key==="disclaimFlag")?.value
            
            if(newPgaFlag?.disclaimFlag === "Y"){
              const payload = {
                "eventType": "SAVE_ENTRY_SUMMARY_FORM",
                "eventTime": Date.now(),
                "eventMessage": {
                    "descriptionOfMerchandise": {
                        "entrySummaryInvoices": [
                            {
                                "invoiceId": invoiceId,
                                "merchandiseLineItems": [
                                    {
                                        "shipmentId": window.shipmentId,
                                        "merchandiseId": merchandiseId,
                                        "pgaFlagInfos": [
                                            {
                                                "pgaType": newPgaFlag?.formType,
                                                "pgaGuid": newPgaFlag?.pgaGuid,
                                                "pgaFlagName": newPgaFlag?.pgaType,
                                                "pgaFlagStatus": 1 
                                            }
                                        ]
                                    }
                                ],
                                "shipmentId": window.shipmentId
                            }
                        ]
                    },
                    "shipmentId": window.shipmentId
                }
              }
              const res2 = await HttpClient.custom({
                data:payload,
              })
              if(res2?.data?.eventMessage?.code===200)  newPgaFlag["pgaFlagStatus"]= 1;
            }
           
            if (!newPgaFlag["pgaType"]) newPgaFlag["pgaType"] = responsexx.data.eventMessage["formType"];
            newPGAList.push(newPgaFlag)
            let formtypes = newPGAList.map(a => a.formType || a.pgaType);
            formtypes.push(newPgaFlag.formType);
            usedFlagsXX.push(newPgaFlag.pgaGuid);
            await new Promise(r => setTimeout(r, 200));
            await savePGAItemField(newPgaFlag.pgaGuid, currentpgaitems, merchandiseId, onepgaact.pgaType, {});
            await new Promise(r => setTimeout(r, 200));
            if(!newPgaGuid){//if this value exists we overwrote the old pga, don't add another
              updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "selectedFormTypes", formtypes)
              updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "pgaFlagInfos", newPGAList)
            }


          }
        }, 2250)
      }
      setTimeout(()=>{
        this.setState({doingHistoryStuff:false});
      },2250+((myarrayofpgadata||[]).length*1500))
    })
  }

  // Check field Validity
  validateField(lineItemIndex, fieldName, value) {
    // let warning = 0
    const newState = Object.assign({}, this.state)
    newState.formInfo[fieldName] = value
    this.setState(newState)
    DoMFields[fieldName].errors = []
    DoMFields[fieldName].valid = true
    if (DoMFields[fieldName].rules && DoMFields[fieldName].rules.length > 0) {
      DoMFields[fieldName].rules.forEach((rule) => {
        console.log(rule.test(value))
        if (!rule.test(value)) {
          DoMFields[fieldName].errors.push(rule.message)
          DoMFields[fieldName].valid = false
        }
      })
    }
    // Object.keys(DoMFields).forEach(field => {
    //   if (!DoMFields[field].valid) {
    //     warning++
    //   }
    // })
    // this.props.updateDOMErrorWarning(warning)
    if (DoMFields[fieldName].errors.length) {
      this.addErrorClass(lineItemIndex + fieldName, DoMFields)
    } else {
      this.removeErrorClass(lineItemIndex + fieldName, DoMFields)
    }
  }
  addErrorClass(fieldName, fieldType) {
    const inputField = document.getElementById(fieldName + window.shipmentId)
    inputField.classList.add('errorInput')
  }

  removeErrorClass(fieldName, fieldType) {
    try {
      const inputField = document.getElementById(fieldName + window.shipmentId)
      inputField.classList.remove('errorInput')
    } catch (e) {
      console.error(e)
    }
  }
  updateDeleteStatus = () => {
    this.setState({
      isDeleting: false,
    })
  }

  dutyAddStatus = () => {
    this.setState({
      isDutyAdding: false,
    })
  }
  
  displayWeightInkg = (unit, weight) => {
    if (unit === 'LB') {
      return (
        <span
          style={{
            fontStyle: 'italic',
            fontSize: '12px',
            position: 'absolute',
          }}
        >
          Weight in KG : {(parseFloat(weight) * 0.453592).toFixed(2)}
        </span>
      )
    }
  }
  hasADCVD = (merchandiseId) => {
    if (!this.state.mystate.DescriptionOfMerchandise) return false

    var mymerch =
      this.state.mystate.DescriptionOfMerchandise.merchandiseLineItems.filter(
        (lineitem) => lineitem.merchandiseId == merchandiseId
      )
    //  console.log('mymerch: ', mymerch);
    if (mymerch.length != 1) return false
    var myduty = mymerch[0].merchandiseDuties.filter(
      (objj) => objj.isCommodityDuty == 1
    )
    //   console.log('myduty: ', myduty);
    //.hsDataDtl.adCvdApplicable == 2
    if (myduty.length != 1) return false
    return myduty[0].hsDataDtl.adCvdApplicable == 1
  }

  enableDisableFrom = (enableLineItem) => {
    this.setState({
      enableLineItem: enableLineItem,
    })
  }

  showHideLineItem = () => {
    this.setState({ showLineItem: !this.state.showLineItem })
  }

  isUserFee = dutyType => {
    return ((dutyType+"").indexOf("_FEE")>1)
  }

  render() {
    let {
      countryList,
      showFrightData,
      updateMerchLineItemFeild,
      updateMerchLineItemObject,
      lineItemIndex,
      commercialDescription,
      invoiceCurrencyValue,
      merchandiseDuties,
      productTag,
      setHSDTL,
      handleDutyItemContextSwitch,
      countryOfOrigin,
      permitTypeCode,
      permitNumber,
      productClaimCode,
      saveDescriptionOfMerchandiseLine,
      clearDescriptionOfMerchandiseLine,
      saveMerchDutyItem,
      merchandiseId,
      htsus,
      tfdIndicator,
      partRefreshFlag,
      IRTax,
      irInfo,
      internalRevenueAccountingClassCodesList,
      mpfFee,
      hmfFee,
      otherFee,
      totalLineItems,
      manufacturerHeaderIdUnderPartiesTab,
      grossWeightUnits,
      grossWeightWeight,
      splProgramList,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      rbCounterID,
      charges,
      updateMerchFeild,
      addHeaderItemParty,
      addUserFee,
      saveMerchandiseField,
      updateMerchDutyItemFeild,
      updateMerchDutyItemObject,
      updateTotalValueAndGrossWeight,
      handleLineItemContextSwitch,
      removeMerchandiseLineItem,
      updateMerchLineItemPgaObject,
      //updateTotals,
      availableProductClaimCode,
      createPGA,
      isDisabled,
      // userFee actions
      userFeeCodes,
      userFees,
      removeUserFee,
      excemptUserFee,
      manufacturerName,
      disclaimUserFee_dd,
      updateUserFee,
      // permit types/certificates
      permitTypeCodesList,
      isAdCvdApplicable,
      updateType,
      hsDataDtl,
      saveLineReason,
      fieldValidation,
      headerParties,
      saveLineItemFeild,
      updateLineItemFeild,
      invoiceItemIndex,
      invoiceIndex,
      seqNo,
      articleHeader,
      articleSetId,
      invoiceId,
      articleSubComponent,
      updateActorFeild,
      updateHeaderPartyFeild,
      pscData,
      shipmentETA,
      itDate,
      entryDate,
      importerAdditionalDeclarationDetails,
      importerAdditionalDeclarationTypeCodesList,
      pgaFlagInfos,
      allVoluntaryPGAs,
      thisMerchandiseItem,
      allsequenceNumberSorted,
      removeDutyItem,
      administrativeRuling,
      addDeclarations,
      deleteDeclarations,
      totalAdditions,
      totalDeletions
    } = this.props
    const isTotalAdditionDeduction=parseFloat(totalAdditions || 0.0)>0 || parseFloat(totalDeletions || 0.0)>0

    let isEngineView = 'kxEngineBrokerToken' ==window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN;

    let {
      manualAdcvdButtonClicked,
      manualAdcvdButtonClickedThisSession,
    } = this.state;
    manualAdcvdButtonClicked |= hasanyvaluesAdcvd(this.props.adcvd,"cvd") || hasanyvaluesAdcvd(this.props.adcvd,"ad")
    const showAdcvdSection = !!((articleHeader !== 'X' && isAdCvdApplicable === 1) || manualAdcvdButtonClicked);
    const voluntaryAdcvdAdd = articleHeader !== 'X' && !(isAdCvdApplicable === 1);
    const showManualAddAdcvdButton = voluntaryAdcvdAdd && !manualAdcvdButtonClicked;

    const administrativeRulingTypeList = [
      {value: 'C', description: 'Pre-Classification number, specifically citing the Importer and merchandise'},
      {value: 'P', description: 'A Pre-Approval number'},
      {value: 'R', description: 'A Binding Ruling number'},
    ]
    
    fieldValidation = fieldValidation||{};
    fieldValidation.validObjects_bl = fieldValidation.validObjects_bl ||{};

  


    window.GLOBALLATEST_pgaFlagInfos = window.GLOBALLATEST_pgaFlagInfos ||{};
    window.GLOBALLATEST_pgaFlagInfos[`${merchandiseId}pgaFlagInfos`] = pgaFlagInfos
   let nextPGAIndexToAdd =(hsDataDtl?.pgaMetadata?.tarriffPgaDetails?.length||0) + 10;
   
    function hasPgaComponent(formType){//Anything that has a form goes in here
      switch (formType) {
        case pgaTypes.LACEY:
        case pgaTypes.TSCA:
        case pgaTypes.DISCLAIM_PGA:
        case pgaTypes.NHT_TPE:
        case pgaTypes.NHT_OEI:
        case pgaTypes.NHT_REI:
        case pgaTypes.FDA_FOO:
        case pgaTypes.FDA_DEV:
        case pgaTypes.FDA_TOB:
        case pgaTypes.DEA_DEA:
        case pgaTypes.ATF_ATF:
        case pgaTypes.FDA_RAD:
        case pgaTypes.FDA_DRU:
        case pgaTypes.FDA_COS:
        case pgaTypes.FDA_VME:
        case pgaTypes.FDA_BIO:
        case pgaTypes.APH_AVS:
        case pgaTypes.APH_AAC:
        case pgaTypes.NMFS_SIM:
        case pgaTypes.EPA_VNE:
        case pgaTypes.EPA_ODS:
        case pgaTypes.APH_APQ:
        case pgaTypes.FWS:
        case pgaTypes.EPA_PS1:
        case pgaTypes.EPA_HFC:
        case pgaTypes.EPA_PS2:
        case pgaTypes.EPA_PS3:
        case pgaTypes.AMS_OR:
        case pgaTypes.AMS_OR2:
        case pgaTypes.AMS_MO:
        case pgaTypes.FSI_FSI:
        case pgaTypes.NHT_MVS:
        case pgaTypes.NHT_OFF:
        case pgaTypes.TTB_BER:
        case pgaTypes.TTB_DSP:
        case pgaTypes.TTB_TOB:
        case pgaTypes.TTB_WIN:
        case pgaTypes.OMC_OMC:
        case pgaTypes.NMF_370:
        case pgaTypes.NMFS_HMS:
        case pgaTypes.NMFS_AMR:
          return true;
      }
      return false;
    }


    const createNewPgaSelection = (pgaType,manuallyAddedPage, existingDataFromOldPGA,parentThis) => {
        if(((window["RATELIMITCREATE"+pgaType+merchandiseId]||0)+(manuallyAddedPage?500:5000)) > Date.now()) return;
          window["RATELIMITCREATE"+pgaType+merchandiseId]=Date.now();
      // savePGAItemField(null/* new pga*/,[], merchandiseId, pgaType, {isManuallyAddedPga:manuallyAddedPage}).then((response)=>{
        if(parentThis && parentThis.parentThis_pq){
          parentThis.parentThis_pq.setState({["PGACREATION"+parentThis.parentThisIndex_pq]:"Creating a "+pgaType});
        }
        getTargetPGAForm(pgaType,null /*new pga*/, merchandiseId, {isManuallyAddedPga:manuallyAddedPage}).then(responsexx => {
          if(parentThis && parentThis.parentThis_pq){
            parentThis.parentThis_pq.setState({["PGACREATION"+parentThis.parentThisIndex_pq]:null});
          }
          setTimeout(()=>{
            document.getElementById("RELOAD_THIS_PGA_"+merchandiseId)&& document.getElementById("RELOAD_THIS_PGA_"+merchandiseId).click();
          },50);
          console.log('newPGAListnewPGAList:rrr ', responsexx);
          let newPGAList = window.GLOBALLATEST_pgaFlagInfos[`${merchandiseId}pgaFlagInfos`]||[]
          let newPgaFlag = {}
          let keys = ["ediSeqOrder","isManuallyAddedPga","lastModifiedTimeInMs","pgaGuid","pgaType","createdTimeInMs","formType"];
          let worked = false;
          if(newPGAList && newPGAList.length){
            for(let key2 of Object.keys(newPGAList[0]||{})){
              newPgaFlag[key2]= responsexx.data.eventMessage[key2];
            }
          }
          for(let key of keys){
            newPgaFlag[key]= responsexx.data.eventMessage[key];
            worked |= newPgaFlag[key];
          }
          newPgaFlag["isManuallyAddedPga"] = !!newPgaFlag["isManuallyAddedPga"];//make sure this isn't null
          if(!worked){
            window.alert("PGA ADDITION FAILED: "+responsexx?.data?.eventMessage?.msg)
            return;
          }
          if(!newPgaFlag["pgaType"])newPgaFlag["pgaType"]=responsexx.data.eventMessage["formType"];                        
          newPGAList.push(newPgaFlag)
          let formtypes = newPGAList.map(a=>a.formType||a.pgaType); 
          formtypes.push(newPgaFlag.formType)
          updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "selectedFormTypes", formtypes)
          updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "pgaFlagInfos", newPGAList)

          if(newPgaFlag.pgaType=="DISCLAIM_PGA"){
            savePGAItemField(newPgaFlag.pgaGuid, [
              
              {
                        "key": "disclaimCode",
                        "value": "A",
                        "dataType": "STRING",
                        "isOptional": "Y",
                        "uiLabel": "Disclaim Code",
                        "uiInputType": "DISPLAY",
                        "uiLabelDesc": "Disclaim Code",
                        "PGAId": "disclaimCode",
                        "isRepeated": "N",
                        "lengthClass": "1A",
                        "value": "A"
                      },
                      {
                        "key": "disclaimFlag",
                        "dataType": "STRING",
                        "uiLabel": "Disclaim Flag",
                        "uiInputType": "DISPLAY",
                        "uiLabelDesc": "Disclaim Flag",
                        "PGAId": "disclaimFlag",
                        "isRepeated": "N",
                        "value": "Y"
                      }
            ], merchandiseId, newPgaFlag.pgaType)
          }
          let leftSideUnionOfTwoPGADatas =(oldPgaItems,newPgaItems)=>{
            let itemsToPreserve = [];
            for(let oneOldItem of oldPgaItems){
              if(oneOldItem.PGAId == "dateOfSign")continue;
              if(oneOldItem.PGAId == "govtAgencyProgramCode")continue;
              for(let oneNewItem of newPgaItems){
                let isEqual=true;
                for(let compareFields of ['PGAId','dataType','lengthClass','uiLabel']){
                  if(oneNewItem[compareFields] != oneOldItem[compareFields])isEqual=false;
                }
                if(isEqual){
                  itemsToPreserve.push(oneOldItem);
                  break;
                }
              }
            }
            let hasDisclaimFlag =!!itemsToPreserve.find(a=>a.PGAId.includes("disclaimFlag"));
            let hasDisclaimCode =!!itemsToPreserve.find(a=>a.PGAId.includes("disclaimCode"));
            if(hasDisclaimCode != hasDisclaimFlag){
              itemsToPreserve = itemsToPreserve.filter(a=>!["disclaimCode","disclaimFlag"].includes(a.PGAId))
            }
            itemsToPreserve = itemsToPreserve.filter(oneitem=>
              oneitem.PGAId.indexOf("aoc")!=0 &&
              oneitem.PGAId.indexOf("govtAgencyProcessingCode")!=0
              
            )
           return itemsToPreserve;
          }
          
          if(existingDataFromOldPGA && pgaType.startsWith("EPA_PS")){//for now, restrict to PSX PGAs
            let myUnion = leftSideUnionOfTwoPGADatas(existingDataFromOldPGA.pgaItems||[], responsexx.data.eventMessage.pgaItems||[]);
            if(myUnion?.length){
              setTimeout(()=>{
                savePGAItemField(newPgaFlag.pgaGuid, myUnion, merchandiseId, newPgaFlag.pgaType)
                setTimeout(()=>{
                  document.getElementById(`RELOAD_THIS_PGA_${newPgaFlag.pgaGuid}`) &&document.getElementById(`RELOAD_THIS_PGA_${newPgaFlag.pgaGuid}`).click()
                },2500)//takes a while for backend to figure out the new values, so wait
              },500)//takes a while for backend to figure out the new values, so wait
            }

          }
        })
      // })
    }

   let currentFdaProgram = (pgaFlagInfos||[]).map(dddd=>dddd?.formType||dddd?.pgaType)?.find(a=>a?.includes("FDA"))
   const allPgaListForDropdown = this.props.launchFrom === 'PRODUCT_HISTORY'?
   []
   :(_.uniq((allVoluntaryPGAs||[])
      .map(parentMetaDataPGA=>parentMetaDataPGA.programDetails
        .map(programDeet=>[parentMetaDataPGA.programName+"_"+programDeet.programCode, programDeet.programCode+"_"+programDeet.programCode, programDeet.formType]).flat())
      .flat() || [])
      .filter(a=>hasPgaComponent(a))
      .filter(aaaa=>{
          let hasDisclaimPga = !!(pgaFlagInfos||[]).find(bbbb=>bbbb.pgaType=="DISCLAIM_PGA"||bbbb.formType=="DISCLAIM_PGA")
          if(aaaa.indexOf("FDA")==0){
            if(hasDisclaimPga)return false;
            if(aaaa == currentFdaProgram)return true;
          }
          for(let alreadyUsedPGA of (pgaFlagInfos||[]).map(cccc=>cccc.formType||cccc.pgaType)){
            if(!alreadyUsedPGA){
              console.log('pgaFlagInfos: ', pgaFlagInfos,(pgaFlagInfos||[]).map(dddd=>dddd.formType||dddd.pgaType));
            }
            let programName = alreadyUsedPGA.split("_")[0]
            if(programName === "NMFS" && aaaa === alreadyUsedPGA) return false //Adding this as a temporary fix to support multiple NMFS PGAs
            if(aaaa.includes(programName)) return false;
          }
          return true;
      })
      .sort()
      .map(a=>{
        return ({id:a,value:a,description:pgaHumanNames[a]})}

      ));

    let { isIRTaxAdding } = this.state

    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
      isDisabled = this.props.isDisabled
      productTag = this.props.prodHistoryFormData.productTag
      merchandiseDuties = this.props.prodHistoryFormData.merchandiseDuties

      // IRTax = this.props.prodHistoryFormData.merchandiseDuties?.duties[0].IRTax
      manufacturerName = this.props.prodHistoryFormData.manufacturerName
      commercialDescription = this.props.prodHistoryFormData.productDescription
      countryOfOrigin = this.props.prodHistoryFormData.originCountry
      // mpfFee =  this.props.prodHistoryFormData.merchandiseDuties?.duties[0].mpf.fee
      // hmfFee =  this.props.prodHistoryFormData.merchandiseDuties?.duties[0].hmf.fee
    }

    let steelExclusionGenericExclusion = (
      whitelistedCodes,
      nameofexclusions,
      validationForExlContainer
    ) => {
      let importerAdditionalDeclarationTypeCodesListCopy =
        importerAdditionalDeclarationTypeCodesList || []
      let mainExclusionlistfromServer = _.get(
        importerAdditionalDeclarationDetails,
        'importerAdditionalDeclarationDetail',
        [{}]
      )//.filter(aaa=>aaa.information!="_BLANK_")
      let combinedExclusionList = mainExclusionlistfromServer
        .concat(
          this.state.addingExclusions.filter(
            (aa) =>
              !mainExclusionlistfromServer
                .map((bb) => bb.typeCode)
                .includes(aa.typeCode)
          )
        )
        .sort((xx, yy) => (xx.typeCode||"").localeCompare(yy.typeCode||""))
      if (whitelistedCodes) {
        importerAdditionalDeclarationTypeCodesListCopy =
          importerAdditionalDeclarationTypeCodesListCopy.filter((a) =>
            whitelistedCodes.includes(a.value)
          )
        combinedExclusionList = combinedExclusionList.filter((a) =>
          whitelistedCodes.includes(a.typeCode)
        )
      }

      let selectablecodes =
        importerAdditionalDeclarationTypeCodesListCopy.filter(
          (a) => !combinedExclusionList.map((b) => b.typeCode).includes(a.value)
        ) || []
      return (
        <React.Fragment>
          {combinedExclusionList.map((importerAddition, xxii) => {
            let { typeCode } = importerAddition
            let exclusionTypeHumanReadable = typeCode.split('_').join(' ')
            if (
              exclusionTypeHumanReadable.toUpperCase() ==
              'PRODUCT EXCLUSION INFORMATION STEEL PRODUCTS'
            ) {
              exclusionTypeHumanReadable = 'STEEL EXCLUSION'
            }
            if(!exclusionTypeHumanReadable.includes("STEEL")){
              exclusionTypeHumanReadable = nameofexclusions;
            }
            let validationForExl =
              validationForExlContainer && validationForExlContainer[typeCode]
            return (
              <Grid.Column
                className='no-field-margin borderEnd '
                key={typeCode + 'AAAAA' + xxii+"xyxx"+merchandiseId}
                width='5'
              >
                <InputField
                  // merchandiseId={data[index] ? data[index].merchandiseId : ''}
                  id={
                    typeCode +
                    'AAAAA' +
                    xxii +
                    'abbc' +
                    invoiceId +
                    'abc' +
                    merchandiseId
                  }
                  isLabel={false}
                  disabled={
                    this.state.enableLineItem === true
                      ? false
                      : isDisabled('permitTypeEnabled')
                  }
                  type={'text'}
                  className={'field-bg'}
                  errors={
                    validationForExl &&
                    importerAddition &&
                    !validationForExl.validationRegexOptional &&
                    !importerAddition.information.match(
                      validationForExl.validationRegex
                    )
                      ? [validationForExl.validationShortExplanation]
                      : []
                  }
                  label={exclusionTypeHumanReadable}
                  labelIcon={
                    validationForExl ? (
                      <PopUpIcon
                        icon='info circle'
                        popupText={validationForExl.validationExplanation}
                      />
                    ) : null
                  }
                  placeholder={exclusionTypeHumanReadable}
                  value={importerAddition.information || ''}
                  maxlength={9}
                  onChange={(value) => {
                    value = (value||"").toUpperCase().replace(/[^a-z0-9]+/gi, "");
                    updateMerchLineItemObject(
                      lineItemIndex,
                      invoiceItemIndex,
                      'importerAdditionalDeclarationDetails',
                      'importerAdditionalDeclarationDetail',
                      mainExclusionlistfromServer
                        .filter((a) => a.typeCode != typeCode)
                        .concat({
                          information: value || '_BLANK_',
                          typeCode: typeCode,
                        })
                    )
                  }}
                  onBlur={(value) => {
                    if(validationForExl?.validationRegexOptional){
                      let invalid = !importerAddition.information.match(
                        validationForExl.validationRegex
                      )
                      if(invalid && !window.confirm(`'${importerAddition.information}' appears invalid. ${validationForExl.validationShortExplanation}. Proceed anyway?!? `)){
                        //don't need to do anything
                      }
                    }
                    saveDescriptionOfMerchandiseLine(
                      lineItemIndex,
                      invoiceItemIndex,
                      'importerAdditionalDeclarationDetails'
                    )
                    let addingExclusions = this.state.addingExclusions //we've added the exclusion in redux, so remove it from the state, they get combined anyway
                    this.setState({ addingExclusions: (addingExclusions||[]).filter((a) => a.typeCode != typeCode) })
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                  clearInput={true}
                />
              </Grid.Column>
            )
          })}
          {!!selectablecodes.length && (
            <Grid.Column className='no-field-margin borderEnd ' width='5'>
              <DropDown
                disabled={
                  this.state.enableLineItem === true
                    ? false
                    : isDisabled('permitTypeEnabled')
                }
                id='exclusion-dropdown'
                direction='left'
                className={
                  'field-bg dropdown100 userfeestyle ' +
                  (this.state.userFeeCode ? ' selectedACode ' : ' ')
                }
                isLabel={false}
                text={displayDropDownItem(
                  `+ Add ${nameofexclusions || ''}`,
                  importerAdditionalDeclarationTypeCodesListCopy
                )}
                data={selectablecodes}
                onChange={(value) => {
                  let addingExclusions = this.state.addingExclusions
                  addingExclusions.push({
                    information: '',
                    typeCode: value,
                  })
                  this.setState({ addingExclusions })
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
              />
            </Grid.Column>
          )}
        </React.Fragment>
      )
    }

    let grossValue = 0.0
    let enteredValue = 0.0
    let allDutiesList = (get(merchandiseDuties, 'duties', merchandiseDuties) || []);
    if(_.isEqual(allDutiesList,{}))allDutiesList=[];
    allDutiesList.map((item) => {
      grossValue = grossValue + parseFloat(item.invoiceCurrencyValue || 0.0)
      enteredValue = enteredValue + parseFloat((showFrightData || isTotalAdditionDeduction) ? (item.adjustedValue || 0.0) : item.enteredValue || 0.0)
    })
    grossValue = grossValue.toFixed(2)
    enteredValue = enteredValue.toFixed(2)
    let formDisabled = this.props.formDisabled
    if (this.state.enableLineItem === true) {
      formDisabled = false
    }
    const lineIndex =
      (lineItemIndex + 1).toString().length === 1
        ? `00${lineItemIndex + 1}`
        : (lineItemIndex + 1).toString().length === 2
        ? `0${lineItemIndex + 1}`
        : (lineItemIndex || 0) + 1
    let isAir =
      (parseInt(this.state.mystate.TransportationInfo.modeOfTransport) >= 40 &&
        parseInt(this.state.mystate.TransportationInfo.modeOfTransport) <=
          49) ||
      this.state.mystate.TransportationInfo.modeOfTransport === 'MOT_AIR'
    let manufacturerParties = (headerParties || []).filter(
      (a) => a.headerPartyType == 'MANUFACTURER'
    )

    let manfacturerFromPartyTab = (manufacturerParties || [])
      .filter((a) => a.headerId == manufacturerHeaderIdUnderPartiesTab)
      .pop()
    let manufacturerId = _.get(manfacturerFromPartyTab, 'mId', '')

    let handleArrowKeysinHistory = (e) => {
      if (
        this.state.showSkuList &&
        this.state.skuList_yh &&
        this.state.skuList_yh.length
      ) {
        if (e.keyCode == 38) {
          //up
          this.setState({
            selectedHistoryItem:
              this.state.selectedHistoryItem == 0
                ? this.state.skuList_yh.length - 1
                : this.state.selectedHistoryItem - 1,
          })
        } else if (e.keyCode == 40) {
          //down
          this.setState({
            selectedHistoryItem:
              (this.state.selectedHistoryItem + 1) %
              this.state.skuList_yh.length,
          })
        } else if (e.keyCode == 27) {
          //esc
          this.setState({ showSkuList: false })
        } else if (e.keyCode == 13) {
          //enter
          let selectedHistoryItem = document.getElementById(
            'clickableselectedhistory' +
              merchandiseId +
              'xnx' +
              this.state.selectedHistoryItem
          )
          selectedHistoryItem && selectedHistoryItem.click()
        } else {
          this.setState({ selectedHistoryItem: 0 })
        }
      } else {
        this.setState({ selectedHistoryItem: 0 })
      }
    }
    let showHideHistoryButton = <></>
    if (this.state.skuList_yh) {
      let isopen = this.state.showSkuList
      const title = `${isopen ? 'Hide' : 'Show'} ${
          this.state.skuList_yh.length?this.state.skuList_yh.length+" ":""
        }product ${
          this.state.skuList_yh.length == 1 ? 'history' : 'histories'
        }`
      
      let mystyles = {
        fontSize: '1.3rem',
        color: '#2185d0',
        cursor: 'pointer',
      }
      showHideHistoryButton = (
        <a
          title={title}
          onClick={() => {
            this.setState({ showSkuList: !this.state.showSkuList })
            
            this.callSEARCH_PRODUCT_LINE_HISTORY_api(
              commercialDescription,
              productTag,
              htsus,
              countryOfOrigin,
              manufacturerId
            )

          }}
          className={
            this.state.showHistoryAnimation + 20000 > Date.now() &&
            this.state.skuList_yh.length
              ? ' jiggle '
              : ' '
          }
        >
          <Icon
            style={mystyles}
            name={`sort amount ${isopen ? 'up' : 'down'}`}
          />
        </a>
      ) //product histories product history
    }

    this.selectedReasons = fetchSelectedReasonCodes(
      this.props.pscData?.lineCodes,
      this.props.merchandiseId
    )
    let pscWarningAlertShow =
      this.selectedReasons.length <= 0 &&
      (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||
        get(this.props, 'pscState.value.state') === 'STATE_PSC_READY')

    let aluminumSmeltAndCastDetails = _.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [{}]).find(a => a.typeCode === "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL")
    const steelSmeltAndCastDetails = _.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [{}]).find(a => a.typeCode === "STEEL_MELT_AND_POUR_COUNTRY_DETAIL")
    let softwoodLumberFeeDetails = _.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [{}]).find(a => a.typeCode === "SOFTWOOD_LUMBER_EXPORT")
    let cbmaDeclarationDetails = _.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [{}]).find(a => a.typeCode === "CBMA_PRODUCT_DETAIL")

    let changeAluminumSmeltAndCastDetails = (attribute, value) => {
      let mainExclusionlistfromServer = JSON.parse(JSON.stringify(_.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])));
      let updatedList = mainExclusionlistfromServer.filter((a) => a.typeCode != "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL")
      let aluminumSmeltAndCastDetailsObject = JSON.parse(JSON.stringify(mainExclusionlistfromServer.filter((a) => a.typeCode == "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL")[0]))
      let russiaExists = false, addRussiaDuties = false, russiaRemoved = true

      const countryAttributes = ["primaryCountryOfSmelt", "secondaryCountryOfSmelt", "countryOfCast"]
      countryAttributes.map(attr => {
        if(aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail[attr] === "N/A"){
          aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail[attr] = ""
        }
        else if(aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail[attr] === "RU"){
          russiaExists = true
        }
        if(attr === attribute && value === "RU"){
          addRussiaDuties = true
        }
      })

      aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail[attribute] = value

      /*
      isPrimaryCountryOfSmeltApplied: "yes"
      isSecondCountryOfSmeltApplied: "no"
      isUsProduct: "no"
      primaryCountryOfSmelt: "AX"
      secondaryCountryOfSmelt: ""*/
      if(attribute == "isPrimaryCountryOfSmeltApplied" && value =="no"){
        aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail["primaryCountryOfSmelt"]="";
      }
      if(attribute == "isSecondCountryOfSmeltApplied" && value =="no"){
        aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail["secondaryCountryOfSmelt"]="";
      }
      if(attribute === "isUsProduct"){
          if(value === "yes"){
            aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail.primaryCountryOfSmelt = ""
            aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail.secondaryCountryOfSmelt = ""
            aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail.isPrimaryCountryOfSmeltApplied = "no"
            aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail.isSecondCountryOfSmeltApplied = "no"
            aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail.countryOfCast = "US"
          }
          else{
            aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail.countryOfCast = ""
          }
      }

      countryAttributes.map(attr => {
        if(aluminumSmeltAndCastDetailsObject.aluminumSmeltAndCastCountryDetail[attr] === "RU"){
          russiaRemoved = false
        }
      })

      if(!russiaExists && addRussiaDuties){
        addAdditionalRussiaDuties(aluminumSmeltAndCastDetailsObject)
      }
      if(russiaExists && russiaRemoved){
        removeAdditionalRussiaDuties()
      }
      
      updatedList = updatedList.concat(aluminumSmeltAndCastDetailsObject)
      console.log('updatedxList: ', updatedList);
      updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
      saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', {'importerAdditionalDeclarationDetail': updatedList})
      this.props.validateFormzz(true)
    }

    let addAdditionalRussiaDuties = aluminumSmeltAndCastDetailsObject => {
      const targetHTS = Object.values(russiaMetaData).map(a=>Object.keys(a)).reduce((a,b)=>a.concat(b),[])
      const mainHTS = merchandiseDuties[0].htsus
      const primaryHTSMatch = targetHTS.find(t => mainHTS.startsWith(t))
      const entryAttr = this.props.EntryTypeInfo?.entryType === "06" ? "FTZ" : "nonFTZ"
      const additionalMetaData = russiaMetaData[entryAttr][primaryHTSMatch]
      const alreadyAdded = merchandiseDuties.filter(duty => duty.htsus === additionalMetaData?.hts)?.length > 0
      if(alreadyAdded || !additionalMetaData){
        return
      }
      else{
        createMerchandiseDutyItem(
          invoiceItemIndex,
          invoiceId,
          merchandiseId,
          lineItemIndex,
          this.dutyAddStatus,
          additionalMetaData.hts,
          pscData.pscShipmentId,
          {
            htsNo: additionalMetaData.hts,
            // displayDescription: additionalMetaData.htsDescription,
            applicableDuty: additionalMetaData.dutyRate
          }
        )
      }
    }
    let changeSteelSmeltAndCastDetails = (hashset) => {
      let updatedList = JSON.parse(JSON.stringify(_.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])));
      let steelItem = updatedList.find(aaa => aaa.typeCode === "STEEL_MELT_AND_POUR_COUNTRY_DETAIL");
      steelItem.steelMeltAndPourCountryDetail = { ...steelItem.steelMeltAndPourCountryDetail, ...hashset};
      updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList);
      saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', {'importerAdditionalDeclarationDetail': updatedList})
      this.props.validateFormzz(true)
    }


    let removeAdditionalRussiaDuties = () => {
      const targetHTS = Object.values(russiaMetaData).map(a=>Object.keys(a)).reduce((a,b)=>a.concat(b),[])
      const mainHTS = merchandiseDuties[0].htsus
      const primaryHTSMatch = targetHTS.find(t => mainHTS.startsWith(t))
      const entryAttr = this.props.EntryTypeInfo?.entryType === "06" ? "FTZ" : "nonFTZ"
      const additionalMetaData = russiaMetaData[entryAttr][primaryHTSMatch]
      let merchandiseDutyId, index
      merchandiseDuties.forEach((duty, idx) => {
        if(duty.htsus === additionalMetaData.hts){
          merchandiseDutyId = duty.merchandiseDutyId
          index = idx
        }
      })
      removeDutyItem(
        merchandiseId,
        [merchandiseDutyId],
        lineItemIndex,
        invoiceItemIndex,
        0,//unused
        () => {},
        pscData.pscShipmentId
      );
    }

    let addImporterAdditionalDeclarationDetails = userFeeType => {
      this.setState({forceRerender:Date.now()});
      let mainExclusionlistfromServer = JSON.parse(JSON.stringify(_.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])))
      let updatedList = mainExclusionlistfromServer

      if(userFeeType === "SOFTWOOD_LUMBER_FEE"){
        updatedList = mainExclusionlistfromServer.filter((a) => a.typeCode != "SOFTWOOD_LUMBER_EXPORT")

        updatedList = updatedList.concat({
          typeCode: "SOFTWOOD_LUMBER_EXPORT",
          "softwoodLumberDetail": {
            "declaration": "Y"
          }
        })
      }
      else if(userFeeType === "CBMA_PRODUCT_DETAIL"){
        let existingItem = mainExclusionlistfromServer.find((a) => a.typeCode == "CBMA_PRODUCT_DETAIL");
        if(existingItem){
          existingItem.cbmaDeclarationDetail.claimCode = "C";
        } else {
          updatedList = updatedList.concat({
            typeCode: "CBMA_PRODUCT_DETAIL",
            "cbmaDeclarationDetail": {
              "claimCode": "C",
              // "foreignProducerIdentifier": "",
              // "foreignProducerName": "",
              "flavorContentCredit": "",
              foreignProducerIdentifier:"TTB-FP-",
              foreignProducerName:"",
              rateCode:"",
              taxRate:"",
            }
          })
        }
      }
      
      let existingImporterAddition = thisMerchandiseItem?.importerAdditionalDeclarationDetails?.importerAdditionalDeclarationDetail;
      if(!existingImporterAddition || !_.isEqual(updatedList,existingImporterAddition)){
        updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
        saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', {'importerAdditionalDeclarationDetail': updatedList})
      }
    }

    let removeImporterAdditionalDeclarationDetails = userFeeType => {
      this.setState({forceRerender:Date.now()});
      let mainExclusionlistfromServer = JSON.parse(JSON.stringify(_.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])));
      let updatedList = mainExclusionlistfromServer

      if(userFeeType === "SOFTWOOD_LUMBER_FEE"){
        updatedList = mainExclusionlistfromServer.filter((a) => a.typeCode != "SOFTWOOD_LUMBER_EXPORT")
        updatedList = updatedList.concat({
          typeCode: "SOFTWOOD_LUMBER_EXPORT",
          "softwoodLumberDetail": {
            "declaration": "_BLANK_",
            "exportPrice": "-999",
            "exportCharge": "-999"
          }
        })
      }
      else if(userFeeType === "CBMA_PRODUCT_DETAIL"){
        if(mainExclusionlistfromServer.find((a) => a.typeCode == "CBMA_PRODUCT_DETAIL")){
          mainExclusionlistfromServer.find((a) => a.typeCode == "CBMA_PRODUCT_DETAIL").cbmaDeclarationDetail.claimCode = "N";
        }
      }
      let existingImporterAddition = thisMerchandiseItem?.importerAdditionalDeclarationDetails?.importerAdditionalDeclarationDetail;
      if(!existingImporterAddition || !_.isEqual(updatedList,existingImporterAddition)){
        updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
        saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', {'importerAdditionalDeclarationDetail': updatedList})
      }
    }

    let updateSoftwoodLumberDetail = (attribute, value, dontSave=false) => {
      this.setState({forceRerender:Date.now()});
      let mainExclusionlistfromServer = JSON.parse(JSON.stringify(_.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])));
      let updatedList = mainExclusionlistfromServer.filter((a) => a.typeCode != "SOFTWOOD_LUMBER_EXPORT")
      let softwoodLumberDetailsObject = JSON.parse(JSON.stringify(mainExclusionlistfromServer.filter((a) => a.typeCode == "SOFTWOOD_LUMBER_EXPORT")[0]))

      softwoodLumberDetailsObject.softwoodLumberDetail[attribute] = value

      if(attribute === "exportPrice" || attribute === "exportCharge"){
        const floatingPoint = parseFloat(value)
        const updatedValue = isNaN(floatingPoint) ? 0 : floatingPoint
        softwoodLumberDetailsObject.softwoodLumberDetail[attribute] = "" + (!dontSave ? Math.round(updatedValue) : value)
        updatedList = updatedList.concat(softwoodLumberDetailsObject)
        updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
        if(!dontSave){
          saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', {'importerAdditionalDeclarationDetail': updatedList})
        }
      }
      else{
        softwoodLumberDetailsObject.softwoodLumberDetail[attribute] = value
        updatedList = updatedList.concat(softwoodLumberDetailsObject)
        let existingImporterAddition = thisMerchandiseItem?.importerAdditionalDeclarationDetails?.importerAdditionalDeclarationDetail;
        if(!existingImporterAddition || !_.isEqual(updatedList,existingImporterAddition)){
          updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
          saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', {'importerAdditionalDeclarationDetail': updatedList})
        }
      }
    }

    let updateCbmaDeclarationDetail = (attribute, value) => {
      this.setState({forceRerender:Date.now()});
      let mainExclusionlistfromServer = JSON.parse(JSON.stringify(_.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])));
      let updatedList = mainExclusionlistfromServer.filter((a) => a.typeCode != "CBMA_PRODUCT_DETAIL")
      let cbmaDeclarationDetailsObject = JSON.parse(JSON.stringify(mainExclusionlistfromServer.filter((a) => a.typeCode == "CBMA_PRODUCT_DETAIL")[0]))

      cbmaDeclarationDetailsObject.cbmaDeclarationDetail[attribute] = value

      updatedList = updatedList.concat(cbmaDeclarationDetailsObject)
      updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
    }
 
    let saveImporterAdditionalDeclarationDetails = () => {
      saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails')
    }

    let hasCBMAYes = cbmaDeclarationDetails && cbmaDeclarationDetails.cbmaDeclarationDetail && cbmaDeclarationDetails.cbmaDeclarationDetail.claimCode === "C";
    
    
    let disableFeeIcons = (this.state.enableLineItem === true
      ? false
      : isDisabled('additionalFeeFieldsAreEnabled',Boolean(formDisabled))
      
      );
      
      const hasRulingNumber = administrativeRuling?.rulingNumber && administrativeRuling?.rulingNumber!="_BLANK_";


    let metalExtraDetailsScreen = (metalObject, listName) => {

      const derivativeSteelProduct = metalObject.steelMeltAndPourCountryDetail.countryOfMeltAndPourApplicabilityCode == "yes";
      return <Grid padded className='pga-container' columns='equal' style={{ padding: '5px' }}>
        <span style={{ fontSize: "11px", fontWeight: "600", padding: "0 0 10px 0" }}>STEEL MELT AND POUR COUNTRY DETAIL</span>
        <br />
        <Grid.Row className='merged hts-row prod-hist-display' style={{ padding: '5px' }}>
          <Grid.Column className={'borderStart'}>
          <UpdateTariffs invoiceId={invoiceId} merchandiseId={merchandiseId}>
           {({updateHTS})=> <DropDown
              disabled={
                derivativeSteelProduct ||
                  (formDisabled || metalObject.steelMeltAndPourCountryDetail.countryOfMeltAndPourCode == "NONE")
                  ? true
                  : isDisabled('aluminiumSmeltAndCast')
              }
              id='exclusion-dropdown-primary'
              direction='left'
              className={'field-bg dropdown100'}
              isLabel={false}
              label={<>Country of Melt and Pour
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                <input
                  type='checkbox'
                  checked={
                    metalObject.steelMeltAndPourCountryDetail.countryOfMeltAndPourApplicabilityCode == "yes"
                  }
                  disabled={this.state.enableLineItem ? false :
                    !formDisabled ? false :
                      isDisabled('aluminiumSmeltAndCast')
                  }
                  style={{ margin: "3px",marginTop:'0px' }}
                  onChange={(e) => {
                    const updatedValue = metalObject.steelMeltAndPourCountryDetail.countryOfMeltAndPourApplicabilityCode == "no" ? "yes" : "no"
                    let newresult = { "countryOfMeltAndPourApplicabilityCode": updatedValue, "countryOfMeltAndPourCode": "_BLANK_" }
                    changeSteelSmeltAndCastDetails(newresult)
                  }}
                />
                &nbsp;
                Does not apply: Derivative steel that are products of Mexico only <PopUpIcon basic={true} icon='info circle' popupText={'For derivative steel that are products of Mexico only, the applicability code “OTH” (Other) can be used if an ISO code was not provided in the country of melt and pour field.'} />

              </>}
              text={
                derivativeSteelProduct ? "N/A" :
                  displayDropDownItem(metalObject.steelMeltAndPourCountryDetail.countryOfMeltAndPourCode === "N/A" ? "" :
                    metalObject.steelMeltAndPourCountryDetail.countryOfMeltAndPourCode, countryList)}
              data={countryList}
              onChange={async (value) => {
                changeSteelSmeltAndCastDetails({ "countryOfMeltAndPourCode": value })
                await updateHTS({countryOfSmelt: value})
              }}
              errors={fieldValidation?.validObjects_bl[
                `Merchandiseqwqr${'countryOfMeltAndPourCode'}${merchandiseId}`
              ]}
              newValue={newValue}
              fieldName={fieldName}
              setINPUTID={setINPUTID}
              penClicked={penClicked}
              shipmentId={shipmentId}
              rbCounterID={rbCounterID}
            />}
            </UpdateTariffs>
            {/* <i aria-hidden="true" class="dropdown icon" style={{"position": "absolute", "right": "4px", "top": "8px", "opacity": "0.3"}}></i> */}
          </Grid.Column>

        </Grid.Row>
        <Grid.Row className='merged hts-row prod-hist-display' style={{ padding: '5px' }}>

          {document.getElementById("usdisbutton") &&
            <div style={{ margin: '5px' }} className="dashedContainer">
              A steel mill certificate is required to be submitted via DIS for iron or steel imports classifiable in Chapter 72 or headings 7301 to 7307 of the HTSUS
              <br />
              <Button
                style={{ marginTop: '3px' }}
                className="btn-add"
                data-defaultDocumentType="NMF_01"
                onClick={() => {
                  window.currentPGA = "NMFS_HMS"
                  document.getElementById("usdisbutton") && document.getElementById("usdisbutton").click();
                }}
              >
                Show DIS Popup
              </Button>
            </div>
          }
        </Grid.Row>


      </Grid>
    }

    let groupingColor = "";


    for(let oneAggregation of (this.props.EntryTypeInfo?.merchandiseAggregationRelList||[])){
      
    
      if([oneAggregation.aggregatedMerchandiseId, oneAggregation.unaggregatedMerchandiseId].includes(merchandiseId)){
        let brokerHash = Math.abs((oneAggregation.aggregatedMerchandiseId + "").hashCode());
        groupingColor = `rgb(${(brokerHash & 255) | 224}, ${(Math.floor(brokerHash / 256) & 255) | 224
          }, ${(Math.floor(brokerHash / (256 * 256)) & 255) | 224})`;

      }
    }

    return (
      <div
        className={
          'merchandise-line-item ' + ('lineitemindexzz' + lineItemIndex)
        }
        style={groupingColor?{backgroundColor:groupingColor}:{}}
        onMouseOver={() => {
          if (this.state.hasDoneProductHistorySearch) return
          if (!commercialDescription && !productTag) return
          if (this.props.launchFrom === 'PRODUCT_HISTORY') return
          // this.callSEARCH_PRODUCT_LINE_HISTORY_api(
          //   commercialDescription,
          //   productTag,
          //   htsus,
          //   countryOfOrigin,
          //   manufacturerId
          // )
          this.setState({
            hasDoneProductHistorySearch: true,
            showHistoryAnimation: Date.now(),
          })
        }}
        title={
          pscWarningAlertShow
            ? 'Must select a PSC reason before you can edit'
            : ''
        }
      >
        <a name={'adcvdtggt' + merchandiseId}></a>
        <table style={{ width: '100%', marginTop: '10px' }}>
          <tbody>
            <tr style={{display:"flex", justifyContent: this.state.showLineItem ? "space-between" : "flex-start", alignItems:"center"}} >
              <td style={{display:"flex"}} >
                <div
                  id={
                    (this.state.showLineItem
                      ? `minus-adcvdtggt`
                      : `plus-adcvdtggt`) + merchandiseId
                  }
                  className='stepNumber'
                  onClick={() => {
                    this.showHideLineItem()
                  }}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height:"2rem"
                  }}
                >
                  <Icon
                   style={{
                    display:"flex",
                    justifyContent:"center",
                    alignItems:"center",
                  }}
                    name={
                      this.state.showLineItem ? `minus circle` : `plus circle`
                    }
                  />
                  {!this.state.showLineItem && 
                    <a href="#" 
                    onFocus={() => {
                      this.setState({ showLineItem:true})
                      setTimeout(()=>{
                        document.getElementById(`${lineItemIndex}commercialDescription${shipmentId}`) && document.getElementById(`${lineItemIndex}commercialDescription${shipmentId}`).focus();
                      },20)
                    }}>
                  </a>}
                  {articleHeader ? articleHeader + ':' : ''}
                  <span
                    style={{marginTop:"1px"}}
                  
                  >
                  {lineIndex} 
                  </span>
                </div>
                &nbsp;
                {!(this.props.launchFrom === 'PRODUCT_HISTORY') &&
                  <div
                    className='stepNumber'
                    onClick={() => {
                      this.showHideLineItem()
                    }}
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      height:"2rem"
                    }}
                  >
                    SEQ:&nbsp;
                    {(allsequenceNumberSorted.indexOf((thisMerchandiseItem || {}).seqNo || 0)+1).toString().padStart(3, '0')}
                  </div>
                }
                &nbsp;
                 {!(this.props.launchFrom === 'PRODUCT_HISTORY') && this.props.cbpSeqNo &&
                  <div
                    className='stepNumber'
                    onClick={() => {
                      this.showHideLineItem()
                    }}
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      height:"2rem"
                    }}
                  >
                    <span style={{width:"4rem"}} >
                    CBP:&nbsp;
                    {(this.props?.cbpSeqNo).toString().padStart(3, '0')}
                    </span>
                  </div>
                }
              </td>
              {this.state.showLineItem &&
                (this.props.articleSubComponent && articleHeader === 'V'
                  ? !(this.props.articleSubComponent[0] === merchandiseId)
                  : true) && (
                  //this.state.showLineItem && totalLineItems > 1 && (this.props.articleSubComponent && articleHeader === 'V'? !(this.props.articleSubComponent[0] === merchandiseId) : true) && (
                  <td style={{ width: "calc(100% - 300px)" }}>
                    <Grid.Column className='delete-line-item'>
                      <RefreshPart merchandiseId={merchandiseId} shipmentId={shipmentId} partRefreshFlag={partRefreshFlag} />
                      <Button
                        className={'del-line-item-btn'}
                        basic
                        color='blue'
                        compact
                        circular
                        onClick={() => {
                          let errorMsg = `Are you sure? Remove Merchandise Line Item ${
                            articleHeader || ''
                          }: ${lineIndex} of Invoice Item: ${invoiceIndex}`
                          if (!window.confirm(errorMsg)) return
                          this.setState({
                            isDeleting: true,
                          })
                          removeMerchandiseLineItem(
                            merchandiseId,
                            invoiceItemIndex,
                            lineItemIndex,
                            this.updateDeleteStatus,
                            articleSetId,
                            articleHeader,
                            articleSubComponent,
                            pscData.pscShipmentId
                          )
                        }}
                        disabled={
                          this.props.isPscMode
                            ? false
                            : isDisabled('addRemoveMerchandiseLineItems',Boolean(formDisabled))
                        }
                      >
                        {!this.state.isDeleting ? (
                          <span>
                            <Icon name='trash alternate outline' />
                            {/* <!-- text goes here-- */}
                          </span>
                        ) : (
                          <span>
                            <Loader
                              active
                              inline
                              size='mini'
                              style={{ marginRight: '10px' }}
                            />
                            Deleting Line Item
                          </span>
                        )}
                      </Button>
                    </Grid.Column>
                  </td>
                )}
              {!this.state.showLineItem && (
                <td
                  onClick={() => {
                    this.showHideLineItem()
                  }}
                  className={'lineItemCollapsedMode'}
                >
                  
                  {htsus && (
                    <span className='collapsedItem' title={`HTS# ${htsus}`}>
                      {htsus}
                    </span>
                  )}
                     {trim(productTag) && (
                    <span className='collapsedItem' title={`SKU#: ${trim(productTag)}`}>
                      SKU# - {trim(productTag)}
                    </span>
                  )}
                  <span className='collapsedItem'>
                    {commercialDescription || this.props.productDescription ? (
                      <span
                        title={`Commercial Description: ${commercialDescription}`}
                      >
                        {commercialDescription || this.props.productDescription}
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                  {
                    trim(grossValue) && (
                      <span
                        className="collapsedItem"
                        title={`Gross Value $${trim(grossValue)}`}
                      >
                        ${trim(grossValue)}
                      </span>
                    )
                  }
                  <span
                    className='collapsedItem'
                    style={{ textAlign: 'right', marginRight: '20px' }}
                  >
                    {enteredValue ? (
                      <span title={`Entered Value: $${enteredValue}`}>
                        ${enteredValue}
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                  <span className='collapsedItem small'>
                    {(countryOfOrigin || this.props.originCountry) && (
                      <span
                        title={`Country of Origin: ${
                          countryOfOrigin || this.props.originCountry
                        }`}
                      >
                        {countryOfOrigin || this.props.originCountry}
                      </span>
                    )}
                  </span>
                  <span className='collapsedItem'>
                    {productClaimCode && (
                      <span
                        title={`TRADE AGREE./SPL PRG. ${displayMasterItem(
                          productClaimCode === '_BLANK_'
                            ? 'NONE'
                            : productClaimCode,
                          splProgramList
                        )}`}
                      >
                        {displayMasterItem(
                          productClaimCode === '_BLANK_'
                            ? 'NONE'
                            : productClaimCode,
                          splProgramList
                        )}
                      </span>
                    )}
                  </span>
                  {tfdIndicator === "1" ?
                    <span className='collapsedItem'>
                        <span>TFD</span>
                    </span>: 
                  null}
                </td>
              )}
            </tr>
          </tbody>
        </table>
        {this.state.showLineItem && (
          <React.Fragment>
            <Grid width='equal' className='blk4 line-items'>
              {get(this.props, 'pscData.pscShipmentId') && (
                <Grid.Row>
                  <Grid.Column className='firstCol no-field-margin'>
                    <PscLineItemReason
                      pscState={this.props.pscState}
                      selectedOptions={this.selectedReasons}
                      saveLineReason={saveLineReason}
                      merchandiseId={merchandiseId}
                      enableDisableFrom={this.enableDisableFrom}
                      lineItemIndex={lineItemIndex}
                      invoiceItemIndex={invoiceItemIndex}
                      currentJobData={this.props.currentJobData}
                      kxUserBasicInfo={this?.props?.kxUserBasicInfo}
                    />
                  </Grid.Column>
                </Grid.Row>
              )}
            </Grid>
          </React.Fragment>
        )}
        {this.state.showLineItem &&
          this.state.addedNewManufacturer &&
          'ADDED NEW MANUFACTURER! Look to parties tab'}
        {this.state.showLineItem && (
          <Grid
            padded
            className='nopadcol blk2 extra-fees vertically top-row-fees'
            style={{ top: '5px' }}
            columns='equal'
          >
            <Grid.Row className='merged hts-row commercial-desc-row'>
              <Grid.Column className='no-field-margin borderStart noBottomBorders'>
                <InputField
                  // merchandiseId={data[index] ? data[index].merchandiseId : ''}
                  isLabel={false}
                  id={`${lineItemIndex}commercialDescription`}
                  maxlength="35"
                  errors={
                    !commercialDescription
                      ? ['Commercial Description can not be empty']
                      : fieldValidation?.validObjects_bl[
                          `Merchandiseqwqr${'commercialDescription'}${merchandiseId}`
                        ]
                  }
                  disabled={
                    this.state.enableLineItem === true
                      ? false
                      : isDisabled('commercialDescriptionSkuEnabled',Boolean(formDisabled))
                  }
                  type={'text'}
                  className={'field-bg'}
                  label={'COMMERCIAL DESCRIPTION'}
                  value={commercialDescription}
                  handleFocus={() => {
                    this.setState({ showSkuListLastFocused: "commercialDescription" });
                    this.setState({ showSkuList: false })
                  }}
                  onChange={(value) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      this.props.updateFormState(
                        'productDescription',
                        value,
                        '0',
                        null
                      )
                      return
                    }
                    updateMerchLineItemFeild(
                      lineItemIndex,
                      invoiceItemIndex,
                      'commercialDescription',
                      value
                    )
                    clearTimeout(window.debounceVAR)
                    let pTag = isEngineView ? null : productTag;
                    window.debounceVAR = setTimeout(() => {
                      this.callSEARCH_PRODUCT_LINE_HISTORY_api(
                        value,
                        pTag,
                        htsus,
                        countryOfOrigin,
                        manufacturerId
                      )
                      this.setState({
                        showSkuList: true,
                        hasDoneProductHistorySearch: true,
                        showHistoryAnimation: Date.now(),
                      })
                    }, 350)
                  }}
                  onBlur={(value) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      return
                    }
                    saveDescriptionOfMerchandiseLine(
                      lineItemIndex,
                      invoiceItemIndex,
                      'commercialDescription'
                    )
                  }}
                  onKeyUp={(e) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      return
                    }
                    if(e?.key == "ArrowDown" && !this.state.showSkuList){
                       this.setState({ showSkuList: true })
                    }
                    handleArrowKeysinHistory(e)
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                  postLabel={showHideHistoryButton}
                />
                
              </Grid.Column>
              <Grid.Column className='no-field-margin borderEnd  noBottomBorders'>
                <InputField
                  // merchandiseId={data[index] ? data[index].merchandiseId : ''}
                  isLabel={false}
                  id={`${lineItemIndex}productTag`}
                  errors={
                    fieldValidation?.validObjects_bl[
                      `Merchandiseqwqr${'productTag'}${merchandiseId}`
                    ]
                  }
                  disabled={
                    this.state.enableLineItem === true
                      ? false
                      : isDisabled('commercialDescriptionSkuEnabled',Boolean(formDisabled))
                  }
                  type={'text'}
                  className={'field-bg'}
                  label={'SKU/PRODUCT TAG'}
                  labelClassName='productTag'
                  value={productTag}
                  handleFocus={() => {
                    this.setState({ showSkuListLastFocused: "skuProductTag" });
                    this.setState({ showSkuList: false })
                  }}
                  onChange={(value) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      this.props.updateFormState('productTag', value, '0', null)
                      return
                    }
                    clearTimeout(window.debounceVAR)
                    let cDesc = isEngineView ? null : commercialDescription;
                    window.debounceVAR = setTimeout(() => {
                      this.callSEARCH_PRODUCT_LINE_HISTORY_api(
                        cDesc,
                        value,
                        htsus,
                        countryOfOrigin,
                        manufacturerId
                      )
                      this.setState({
                        showSkuList: true,
                        hasDoneProductHistorySearch: true,
                        showHistoryAnimation: Date.now(),
                      })
                    }, 350)
                    updateMerchLineItemFeild(
                      lineItemIndex,
                      invoiceItemIndex,
                      'productTag',
                      value
                    )
                  }}
                  onBlur={(value) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      return
                    }
                    saveDescriptionOfMerchandiseLine(
                      lineItemIndex,
                      invoiceItemIndex,
                      'productTag'
                    )
                  }}
                  onKeyUp={(e) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      return
                    }
                    if(e?.key == "ArrowDown" && !this.state.showSkuList){
                      this.setState({ showSkuList: true })
                   }
                    handleArrowKeysinHistory(e)
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                  postLabel={showHideHistoryButton}
                />
              </Grid.Column>
              {this.state.showSkuList &&
                  this.state.skuList_yh &&
                  this.state.skuList_yh.length > 0 && (
                    <>
                      <div
                        style={{
                          position: 'fixed',
                          top: '0px',
                          left: '-100vw',
                          width: '200vw',
                          height: '100vh',
                        }}
                        onClick={() => {
                          this.setState({ showSkuList: false })
                        }}
                      ></div>
                      <div
                        className={`middropdown ${this.state.showSkuListLastFocused}`}
                        style={{ width: '525px', top: '35px' }}
                      >
                        {' '}
                        {this.state.skuList_yh.map((skuObject, iii) => {
                          if(iii>10)return null;
                          
                          return(
                          <React.Fragment
                            key={skuObject.productLineId + ' ' + iii}
                          >
                            <a
                              className={
                                'dropdownlink' +
                                (iii == this.state.selectedHistoryItem
                                  ? ' selectedarrows '
                                  : ' ')
                              }
                              id={
                                'clickableselectedhistory' +
                                merchandiseId +
                                'xnx' +
                                iii
                              }
                              onClick={() => {
                                setTimeout(() => {
                                  updateMerchLineItemFeild(
                                    lineItemIndex,
                                    invoiceItemIndex,
                                    'productTag',
                                    skuObject.productTag || ''
                                  )
                                  saveDescriptionOfMerchandiseLine(
                                    lineItemIndex,
                                    invoiceItemIndex,
                                    'productTag'
                                  )

                                  updateMerchLineItemFeild(
                                    lineItemIndex,
                                    invoiceItemIndex,
                                    'commercialDescription',
                                    skuObject.productDescription
                                  )
                                  saveDescriptionOfMerchandiseLine(
                                    lineItemIndex,
                                    invoiceItemIndex,
                                    'commercialDescription'
                                  )
                                }, 250)

                                let indexzero = 0
                                updateMerchDutyItemFeild(
                                  invoiceItemIndex,
                                  lineItemIndex,
                                  indexzero,
                                  'htsus',
                                  this.HTScodetoPeriods(skuObject.HTS)
                                )
                                saveMerchDutyItem(
                                  lineItemIndex,
                                  invoiceItemIndex,
                                  indexzero,
                                  'htsus'
                                )

                                let mymann = manufacturerParties.find(
                                  (a) => a.mId == skuObject.manufacturerId
                                )

                                if (!mymann && skuObject.manufacturerId) {
                                  //new manufacturer string code
                                  //ok so the logic is:
                                  //if we have multiple manufacturers, do nothing (%2 of use cases)
                                  //if we have one manufacturer, replace its MID after a confirm
                                  if (manufacturerParties.length == 1) {
                                    confirmAlert({
                                      title: `MID from product history  (${skuObject.manufacturerId}) is different than this shipment (${manufacturerParties[0].mId}).`,
                                      message: `Replace MID with ${skuObject.manufacturerId}?`,
                                      buttons: [
                                        {
                                          label: 'Yes',
                                          onClick: () => {
                                            let mymann = manufacturerParties[0]
                                            let targetindex =
                                              headerParties.indexOf(mymann)
                                            mymann &&
                                              updateMerchLineItemFeild(
                                                lineItemIndex,
                                                invoiceItemIndex,
                                                'manufacturerHeaderIdUnderPartiesTab',
                                                mymann.headerId
                                              )
                                            updateMerchLineItemFeild(
                                              lineItemIndex,
                                              invoiceItemIndex,
                                              'manufacturerId',
                                              skuObject.manufacturerId
                                            )
                                            updateHeaderPartyFeild(
                                              targetindex,
                                              'mId',
                                              skuObject.manufacturerId
                                            )
                                            savemanufacturerIdforManufacturer(
                                              manufacturerParties[0].headerId,
                                              skuObject.manufacturerId,
                                              'MANUFACTURER'
                                            )
                                            if (mymann) {
                                              associateManufacturerIdtoLineItem(
                                                invoiceId,
                                                merchandiseId,
                                                mymann
                                              )
                                            }
                                          },
                                        },
                                        {
                                          label: 'No',
                                          onClick: () => {},
                                        },
                                      ],
                                    })
                                  }

                                  //this code makes a new manufacturer, unused
                                  // saveNewManufacturer({mid:skuObject.manufacturerId, firmName:skuObject.manufacturerName})
                                  //     .then((manresponse)=>{
                                  //       let newpartiesjustadded = _.get(manresponse,"data.eventMessage.newlyAddedActorId.list",[]);
                                  //       addHeaderItemParty(newpartiesjustadded,lineItemIndex);

                                  //       mymann = newpartiesjustadded.filter((a)=>a.mId==skuObject.manufacturerId)[0];
                                  //       updateMerchLineItemFeild(
                                  //         lineItemIndex, invoiceItemIndex,
                                  //         "manufacturerId",
                                  //         skuObject.manufacturerId
                                  //       );
                                  //       updateMerchLineItemFeild(
                                  //         lineItemIndex,
                                  //         invoiceItemIndex,
                                  //         "manufacturerHeaderIdUnderPartiesTab",
                                  //         mymann?mymann.headerId:skuObject.actorid
                                  //       );
                                  // handleLineItemContextSwitch(lineItemIndex , invoiceItemIndex,)
                                  //       saveDescriptionOfMerchandiseLine(
                                  //         lineItemIndex, invoiceItemIndex,
                                  //         'manufacturerId'
                                  //       )
                                  //     })
                                  //   this.setState({addedNewManufacturer:true})
                                  //   setTimeout(()=>{this.setState({addedNewManufacturer:false})},2500);
                                  // }
                                } else {
                                  updateMerchLineItemFeild(
                                    lineItemIndex,
                                    invoiceItemIndex,
                                    'manufacturerId',
                                    skuObject.manufacturerId
                                  )
                                  updateMerchLineItemFeild(
                                    lineItemIndex,
                                    invoiceItemIndex,
                                    'manufacturerHeaderIdUnderPartiesTab',
                                    mymann ? mymann.headerId : skuObject.actorid
                                  )
                                  handleLineItemContextSwitch(
                                    lineItemIndex,
                                    invoiceItemIndex
                                  )
                                  saveDescriptionOfMerchandiseLine(
                                    lineItemIndex,
                                    invoiceItemIndex,
                                    'manufacturerId'
                                  )
                                }
                                if (mymann) {
                                  associateManufacturerIdtoLineItem(
                                    invoiceId,
                                    merchandiseId,
                                    mymann
                                  )
                                }
                                //

                                this.getAdvancedDetailsGET_PRODUCT_LINE_HISTORY_DETAILS(
                                  skuObject.productLineId,
                                  merchandiseId,
                                  lineItemIndex,
                                  invoiceItemIndex,
                                  invoiceId
                                )

                                changeCountryOfOrigin(
                                  skuObject.originCountry,
                                  this.props
                                )

                                setHSDTL(
                                  itDate,
                                  this.props.EntryTypeInfo,
                                  this.HTScodetoPeriods(skuObject.HTS),
                                  invoiceItemIndex,
                                  lineItemIndex,
                                  0,
                                  true,
                                  false
                                )
                                handleDutyItemContextSwitch(
                                  lineItemIndex,
                                  invoiceItemIndex,
                                  indexzero
                                )

                                this.setState({ showSkuList: false })
                              }}
                            >
                              <table className='selectablepredictionbox'>
                                <col style={{ width: '140px' }}></col>
                                <tbody>
                                  <tr>
                                    <td colSpan='2'>
                                      <span style={{ whiteSpace: 'nowrap' }}>
                                        <h5>
                                          {(
                                            skuObject.productDescription || ''
                                          ).substr(0, 45)}
                                        </h5>
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>HTS: </td>
                                    <td>
                                      <b>
                                        {this.HTScodetoPeriods(skuObject.HTS)}
                                      </b>
                                    </td>
                                  </tr>
                                  {skuObject.productTag && (
                                    <tr>
                                      <td>Sku/product tag: </td>
                                      <td>
                                        <b>{skuObject.productTag}</b>
                                      </td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td>Country Of Origin: </td>
                                    <td>
                                      <b>{skuObject.originCountry}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Manufacturer: </td>
                                    <td>
                                      <b>
                                        {skuObject.manufacturerId},{' '}
                                        {skuObject.manufacturerName}
                                      </b>
                                    </td>
                                  </tr>
                                  {skuObject.pgaFlags && (
                                    <tr>
                                      <td>PGAs:</td>
                                      <td>
                                        <b>
                                          {Object.keys(skuObject.pgaFlags)
                                            .map((a) =>
                                              a.replaceAll('Flag', '')
                                            )
                                            .join(', ')
                                            .toUpperCase()}
                                        </b>
                                      </td>
                                    </tr>
                                  )}
                                  {skuObject.fdaManufacturer && (
                                    <tr>
                                      <td>FDA Manufacturer:</td>
                                      <td>
                                        <b>
                                          {skuObject.fdaManufacturer.toUpperCase()}
                                        </b>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </a>
                          </React.Fragment>
                        )})}
                      </div>
                    </>
                  )}
            </Grid.Row>
          </Grid>
        )}
        {this.state.showLineItem && (
          <>
            <DutyItems
              {...this.props}
              launchFrom={this.props.launchFrom}
              parentHts={this.props.parentHts}
              indexVal={this.props.indexVal}
              showFrightData={showFrightData}
              invoiceItemIndex={invoiceItemIndex}
              articleHeader={articleHeader}
              createNewPgaSelection={createNewPgaSelection}
              handleFocusMID={() => {
                this.setState({ showSkuList: false })
              }}
              showLineItem={this.state.showLineItem}
              lineItemIndex={lineItemIndex}
              isDisabled={isDisabled}
              shipmentETA={shipmentETA}
              enableLineItem={this.state.enableLineItem}
            />
            <a
              onClick={() => {
                this.setState({
                  isDutyAdding: true,
                })
                createMerchandiseDutyItem(
                  invoiceItemIndex,
                  invoiceId,
                  merchandiseId,
                  lineItemIndex,
                  this.dutyAddStatus,
                  get(this.props, 'pscData.pscShipmentId')
                )
              }}
              style={{ color: '#1a69a4', cursor: 'pointer', marginLeft: '5px' }}
              disabled={
                this.state.enableLineItem === true
                  ? false
                  : Boolean(isDisabled('addHTS') || this.state.isDutyAdding)
              }
            >
              {!this.state.isDutyAdding ? (
                <span className='add-additional-hts'>
                  <Icon
                    name='add circle'
                    disabled={Boolean(isDisabled('addHTS'))}
                  />{' '}
                  Add Additional HTS
                </span>
              ) : (
                <span>
                  <Loader
                    active
                    inline
                    size='mini'
                    style={{ marginRight: '10px' }}
                  />
                  Adding Additional HTS
                </span>
              )}
            </a>
            <Grid padded className='nopadcol blk2 extra-fees' columns='equal'>
              {(isIRTaxAdding || this.props?.irInfo?.IRTaxClass) && (
                <Grid.Row
                  className='merged hts-row prod-hist-display'
                  style={{ padding: '2px' }}
                >
                  <Grid.Column>
                    <DropDown
                      disabled={
                        this.state.enableLineItem === true
                          ? false
                          : Boolean(formDisabled)
                      }
                      id={`${lineItemIndex}IRTaxClass-dropdown`}
                      direction='left'
                      className={
                        'field-bg dropdown100 userfeestyle borderStart noBottomBorders'
                      }
                      isLabel={false}
                      label={'IR Class Code'}
                      text={
                        irInfo.IRTaxClass
                          ? displayDropDownItem(
                              irInfo.IRTaxClass,
                              internalRevenueAccountingClassCodesList
                            )
                          : 'Choose a Tax Class...'
                      }
                      data={internalRevenueAccountingClassCodesList}
                      onChange={(value) => {
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          0, //duty index
                          'irInfo',
                          'IRTaxClass',
                          value
                        )
                        saveMerchDutyItem(
                          lineItemIndex,
                          invoiceItemIndex,
                          0,
                          'irInfo'
                        )
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column className={'noLeftBorders'}>
                    <InputField
                      subLabelText='%'
                      subLabelClass='right-icon'
                      id={`${lineItemIndex}IRTaxRate`}
                      errors={
                        irInfo.IRTaxRate &&
                        (isNaN(parseFloat(irInfo.IRTaxRate)) ||
                          isNaN(irInfo.IRTaxRate)) && ['Must be a number!']
                      }
                      disabled={
                        !irInfo.IRTaxClass || (
                          this.state.enableLineItem === true
                            ? false
                            : Boolean(formDisabled)
                        )
                      }
                      type={'text'}
                      className={'field-bg noBottomBorders'}
                      label={'IR Tax Rate'}
                      value={!irInfo.IRTaxClass ? "Select IR Tax Class First" : irInfo.IRTaxRate}
                      onChange={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          return
                        }
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          0, //duty index
                          'irInfo',
                          'IRTaxRate',
                          value
                        )
                      }}
                      onBlur={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          return
                        }
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          0, //duty index
                          'irInfo',
                          'IRTaxRate',
                          value
                        )
                        saveMerchDutyItem(
                          lineItemIndex,
                          invoiceItemIndex,
                          0,
                          'irInfo'
                        )
                        //updateTotals()
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <div className='sixteen wide field floating-select borderEnd forcehasBorder noBottomBorders' style={{padding: "10px"}}>
                      {/* <CustomCheckbox
                        id={`${lineItemIndex}IRTaxDeferred`}
                        className='electronic-cert-text'
                        label='IR Tax Deferred'
                        value={irInfo.IRTaxDeferred == 'true'}
                        disabled={true}//this.state.enableLineItem === true ? false : Boolean(formDisabled)}
                        update={value => {
                          updateMerchDutyItemObject(
                            lineItemIndex,
                            invoiceItemIndex,
                            0,//duty index
                            "irInfo",
                            "IRTaxDeferred",
                            value ? 'true' : 'false'
                          );
                          saveMerchDutyItem(lineItemIndex, invoiceItemIndex, 0, 'irInfo')
                        }}
                      /> */}
                      {
                        this.state.cbmaDeclaration && 
                        <div style={{display: "flex", fontSize: "10px"}}>
                          <CustomCheckbox
                            id={`${lineItemIndex}CBMA_CLAIM`}
                            className='cbma-declaration  nolabelwrap'
                            label={"CBMA CLAIM"}
                            value={hasCBMAYes}
                            disabled={
                              this.state.enableLineItem === true
                                ? false
                                : Boolean(formDisabled)
                            }
                            update={value => {
                              if(!hasCBMAYes){
                                addImporterAdditionalDeclarationDetails("CBMA_PRODUCT_DETAIL")
                              }
                              else{
                                removeImporterAdditionalDeclarationDetails("CBMA_PRODUCT_DETAIL")
                              }
                            }}
                          />
                          <PopUpIcon 
                            icon='info circle'
                            pinned={true} 
                            hoverable={true} 
                            position="left center"
                            popupText={
                              <>
                                Filer has or reasonably expects to have a Craft Beverage Modernization Act (CBMA) tax benefit assignment from the foreign producer and expects to file a refund claim with the Alcohol and Tobacco Tax and Trade Bureau (TTB) based on the assigned lower Internal Revenue Tax (IRT) rate or credit.
                                <br/>
                                <a href="https://www.cbp.gov/trade/program-administration/entry-summary/cbma-2017/ace-cbma-tax-rates-table" target="_blank" rel="noopener noreferrer">ACE CBMA Tax Rates Table </a>
                              </>
                            }/>
                        </div>
                      }
                    </div>
                  </Grid.Column>
                </Grid.Row>
              )}
              <Grid.Row className='merged hts-row prod-hist-display finalRowz'>
                {/* <Grid.Column className='firstCol no-field-margin'>
              <InputField
                subLabelText='$'
                disabled={this.state.enableLineItem === true ? false : Boolean(formDisabled)}
                subLabelClass='left-icon'
                id={`${lineItemIndex}charges`}
                labelIcon={<PopUpIcon icon='info circle' popupText={'A minimum of $1 will be enforced for this field due to the EDI requirements set by U.S. Customs and Border Protection.'} />}
                type={'text'}
                className={'field-bg'}
                label={'CHARGES'}
                value={charges}
                isInteger={true}
                handleFocus={e => {
                  e.target.select()
                }}
                onChange={value => {
                  updateMerchDutyItemFeild(
                    lineItemIndex,
                    0,
                    'charges',
                    value.replace(/[^\d.-]/g, '')
                  )
                }}
                onBlur={value => {
                  let newValue = parseFloat(value || 1)
                  // Charges should be a minumum of $1
                  if (newValue < 1) {
                    newValue = 1
                  }
                  updateMerchDutyItemFeild(
                    lineItemIndex,
                    0,
                    'charges',
                    Math.round(newValue).toFixed(2)
                  )
                  saveMerchDutyItem(lineItemIndex, 0, 'charges')
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
              />
              
            </Grid.Column> */}
                {articleHeader !== 'X' && (
                  <Grid.Column className='no-field-margin'>
                    <InputField
                      subLabelText='$'
                      subLabelClass='left-icon'
                      id={`${lineItemIndex}IRTax`}
                      errors={
                        fieldValidation?.validObjects_bl[
                          `Merchandiseqwqr${'IRTax'}${merchandiseId}`
                        ]
                      }
                      disabled={
                        this.state.enableLineItem === true
                          ? false
                          : isDisabled('taxFieldsAreEnabled',Boolean(formDisabled))
                        }
                      type={'text'}
                      className={'field-bg'}
                      label={
                        <>
                          IR TAX&nbsp;
                          <span
                            onClick={() => {
                              this.setState({
                                isIRTaxAdding: !isIRTaxAdding,
                              })
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <Icon
                              name={`${isIRTaxAdding ? 'minus' : 'add'} circle`}
                              color='blue'
                            />
                            {irInfo &&
                            (irInfo.IRTaxClass ||
                              irInfo.IRTaxRate ||
                              irInfo.IRTaxDeferred) ? (
                              <>
                                {irInfo.IRTaxDeferred == 'true'
                                  ? 'Deferred '
                                  : ' '}
                                {irInfo.IRTaxRate
                                  ? ` ${irInfo.IRTaxRate}% `
                                  : ' '}
                                {(irInfo.IRTaxClass || '').replaceAll('_', ' ')}
                              </>
                            ) : (
                              <>Add IR TAX</>
                            )}
                          </span>
                        </>
                      }
                      value={IRTax}
                      isInteger={true}
                      handleFocus={(e) => {
                        e.target.select()
                      }}
                      onChange={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          this.props.updateFormState(
                            'IRTax',
                            value,
                            'merchandiseDuties.duties',
                            0
                          )
                          return
                        }
                        updateMerchDutyItemFeild(
                          invoiceItemIndex,
                          lineItemIndex,
                          0,
                          'IRTax',
                          value.replace(/[^\d.-]/g, '')
                        )
                      }}
                      onBlur={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          return
                        }
                        updateMerchDutyItemFeild(
                          invoiceItemIndex,
                          lineItemIndex,
                          0,
                          'IRTax',
                          parseFloat(value || 0).toFixed(2)
                        )
                        saveMerchDutyItem(
                          lineItemIndex,
                          invoiceItemIndex,
                          0,
                          'IRTax'
                        )
                        //updateTotals()
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                )}
                {/* <Grid.Column className='no-field-margin'>
              <InputField
                subLabelText='$'
                subLabelClass='left-icon'
                id={`${lineItemIndex}otherFee`}
                disabled={this.state.enableLineItem === true ? false : Boolean(formDisabled)}
                type={'text'}
                className={'field-bg'}
                label={'OTHER FEE'}
                value={otherFee}
                isInteger={true}
                handleFocus={e => {
                  e.target.select()
                }}
                onChange={value => {
                  updateMerchDutyItemFeild(
                    lineItemIndex,
                    0,
                    'otherFee',
                    value.replace(/[^\d.-]/g, '')
                  )
                }}
                onBlur={value => {
                  updateMerchDutyItemFeild(
                    lineItemIndex,
                    0,
                    'otherFee',
                    parseFloat(value || 0).toFixed(2)
                  )
                  saveMerchDutyItem(lineItemIndex, 0, 'otherFee')
                  //updateTotals()
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
              />
            </Grid.Column> */}

                {articleHeader !== 'V' && (
                  <>
                    <Grid.Column className='no-field-margin'>
                      <InputField
                        subLabelText='$'
                        subLabelClass='left-icon'
                        labelIcon={
                          this.props.EntryTypeInfo?.entryType == 11 && (
                            <PopUpIcon
                              icon='info circle'
                              popupText={
                                'MPF is read only if the entry type is "11 - Informal"'
                              }
                            />
                          )
                        }
                        id={`${lineItemIndex}mpf`}
                        errors={
                          fieldValidation?.validObjects_bl[
                            `Merchandiseqwqr${'mpf'}${merchandiseId}`
                          ]
                        }
                        disabled={
                          this.props.EntryTypeInfo?.entryType == 11
                            ? true
                            : this.state.enableLineItem === true
                            ? false
                            : isDisabled('taxFieldsAreEnabled',Boolean(formDisabled))
                        }
                        type={'text'}
                        className={'field-bg'}
                        label={`MPF`}
                        value={mpfFee}
                        isInteger={true}
                        handleFocus={(e) => {
                          e.target.select()
                        }}
                        onChange={(value) => {
                          if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                            this.props.updateFormState(
                              'mpf',
                              {
                                rate: '0.00',
                                fee: value.replace(/[^\d.-]/g, ''),
                              },
                              'merchandiseDuties.duties',
                              0
                            )
                            return
                          }
                          updateMerchDutyItemObject(
                            lineItemIndex,
                            invoiceItemIndex,
                            0,
                            'mpf',
                            'fee',
                            value.replace(/[^\d.-]/g, '')
                          )
                        }}
                        onBlur={(value) => {
                          if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                            return
                          }
                          updateMerchDutyItemObject(
                            lineItemIndex,
                            invoiceItemIndex,
                            0,
                            'mpf',
                            'fee',
                            parseFloat(value || 0).toFixed(2)
                          )
                          saveMerchDutyItem(
                            lineItemIndex,
                            invoiceItemIndex,
                            0,
                            'mpf'
                          )
                          //updateTotals()
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    <Grid.Column
                      className={
                        articleHeader === 'X'
                          ? 'borderEnd no-field-margin'
                          : 'no-field-margin'
                      }
                    >
                      <InputField
                        subLabelText='$'
                        subLabelClass='left-icon'
                        id={`${lineItemIndex}hmf`}
                        errors={
                          fieldValidation?.validObjects_bl[
                            `Merchandiseqwqr${'hmf'}${merchandiseId}`
                          ]
                        }
                        disabled={
                          isAir || isWarehouseEntry(this.props.EntryTypeInfo)  ||
                          (this.state.enableLineItem === true
                            ? false
                            : isDisabled('taxFieldsAreEnabled',Boolean(formDisabled))
                            )
                        }
                        type={'text'}
                        className={'field-bg'}
                        label={'HMF'}
                        placeholder={'Harbor Maintenance Fee'}
                        value={hmfFee}
                        isInteger={true}
                        handleFocus={(e) => {
                          e.target.select()
                        }}
                        onChange={(value) => {
                          if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                            this.props.updateFormState(
                              'hmf.fee',
                              value.replace(/[^\d.-]/g, ''),
                              'merchandiseDuties.duties',
                              0
                            )
                            return
                          }
                          updateMerchDutyItemObject(
                            lineItemIndex,
                            invoiceItemIndex,
                            0,
                            'hmf',
                            'fee',
                            value.replace(/[^\d.-]/g, '')
                          )
                          console.log(value, typeof value)
                        }}
                        onBlur={(value) => {
                          if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                            return
                          }
                          updateMerchDutyItemObject(
                            lineItemIndex,
                            invoiceItemIndex,
                            0,
                            'hmf',
                            'fee',
                            parseFloat(value || 0).toFixed(2)
                          )
                          saveMerchDutyItem(
                            lineItemIndex,
                            invoiceItemIndex,
                            0,
                            'hmf'
                          )
                          //updateTotals()
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                  </>
                )}
                {this.props.launchFrom !== 'PRODUCT_HISTORY' &&
                  articleHeader !== 'X' &&
                  userFees &&
                  userFees.map((userFee, index) => {
                    if (!userFee.dutyType)
                      return (
                        <React.Fragment
                          key={index + 'FOOkeyduty'+merchandiseId}
                        ></React.Fragment>
                      )
                      let disableTheFeeInput =   userFee.disclaim == 1 || !this.isUserFee(userFee.dutyType) || disableFeeIcons;
                    return (
                      <Grid.Column
                        key={userFee.dutyType + 'FOOkeyduty'+merchandiseId}
                        className={`no-field-margin`}
                        style={{ flexGrow: '2' }}
                        // key={userFee.dutyType + '-' + index+"Xxx"+merchandiseId}
                      >
                        <InputField
                          subLabelText='$'
                          disabled={disableTheFeeInput}
                          subLabelClass='left-icon'
                          postLabel={
                            <>
                              <Icon
                                color='blue'
                                name='trash alternate outline'
                                disabled={disableFeeIcons}
                                style={{padding:'6px',top:'-12px'}}
                                onClick={() => {
                                  if(disableFeeIcons)return;
                                  if(((this.state.lastUserFees||0) + 1000) > Date.now())return;
                                  removeUserFee(
                                    lineItemIndex,
                                    invoiceItemIndex,
                                    0,
                                    index
                                  )
                                  setTimeout(()=>{
                                    removeImporterAdditionalDeclarationDetails(userFee.dutyType)
                                  }, 1000)
                                  /* if(userFee.isRequired == 0){
                              removeUserFee(lineItemIndex, 0, index)
                            }else{
                              excemptUserFee(lineItemIndex, 0, index) 
                            }*/
                                }}
                              />
                            </>
                          }
                          id={`${lineItemIndex}-${userFee.dutyType}`}
                          type='text'
                          className='field-bg'
                          warnings={userFee.dutyType === 'COTTON_FEE' && userFee.feeValue === "0.00" && !disableTheFeeInput ? ['Cotton fee is missing a value'] : []}
                          errors={
                            fieldValidation?.validObjects_bl[
                              `Merchandiseqwqr${'feeIcons_FXEE'+userFee.dutyType}${merchandiseId}`
                            ]
                          }
                          label={
                            <>
                              {this.isUserFee(userFee.dutyType) && userFee.dutyType.replaceAll('_', ' ')}
                              {this.isUserFee(userFee.dutyType) && userFee.isRequired !== 1 && userFee.dutyType === "COTTON_FEE" && (
                                <>
                                  <input
                                    type='checkbox'
                                    className='dislclaim tinydisclaim'
                                    disabled={disableFeeIcons}
                                    checked={
                                      userFee.disclaim == 1 ? 'checked' : false
                                    }
                                    // value={(this.getFieldValue("disclaimCode", ECCCValues,2) === 'Y')}
                                    //disabled={Boolean(formHide)}
                                    onChange={(e) => {
                                      this.setState({forceRerender:Date.now()});
                                      if(disableFeeIcons)return;

                                      disclaimUserFee_dd(
                                        lineItemIndex,
                                        invoiceItemIndex,
                                        0 /*0 duty index*/,
                                        userFee.dutyType,
                                        userFee.disclaim
                                      )
                                    }}
                                  />{' '}
                                  <span className={`tinyDisclaimLabel ${disableFeeIcons?'disabled':''}`}>
                                    Disclaim
                                  </span>
                                </>
                              )}
                            </>
                          }
                          value={userFee.feeValue}
                          isInteger={true}
                          handleFocus={(e) => {
                            e.target.select()
                          }}
                          onChange={(value) => {
                            this.setState({forceRerender:Date.now()});
                            updateUserFee(
                              lineItemIndex,
                              invoiceItemIndex,
                              0,
                              index,
                              value.replace(/[^\d.-]/g, '')
                            )
                          }}
                          onBlur={(value) => {
                            this.setState({forceRerender:Date.now()});
                            updateUserFee(
                              lineItemIndex,
                              invoiceItemIndex,
                              0,
                              index,
                              parseFloat(value || 0).toFixed(2)
                            )
                            saveMerchDutyItem(
                              lineItemIndex,
                              invoiceItemIndex,
                              0,
                              'additionalDuties'
                            )
                            //updateTotals()
                          }}
                          newValue={newValue}
                          fieldName={fieldName}
                          setINPUTID={setINPUTID}
                          penClicked={penClicked}
                          shipmentId={shipmentId}
                          rbCounterID={rbCounterID}
                        />
                      </Grid.Column>
                    )
                  })}
                {this.props.launchFrom !== 'PRODUCT_HISTORY' &&
                  articleHeader !== 'X' && (
                    <Grid.Column className={'borderEnd no-field-margin'}>
                      <DropDown
                        disabled={disableFeeIcons}
                        id='userfee-dropdown'
                        direction='left'
                        className={
                          'field-bg dropdown100 userfeestyle ' +
                          (this.state.userFeeCode ? ' selectedACode ' : ' ')
                        }
                        isLabel={false}
                        text={displayDropDownItem(
                          this.state.userFeeCode || '+ Add fee',
                          userFeeCodes
                        )}
                        data={userFeeCodes}
                        onChange={(value) => {
                          addUserFee(lineItemIndex, invoiceItemIndex, 0, value)
                          setTimeout(()=>{
                            addImporterAdditionalDeclarationDetails(value)
                          }, 1000)
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                  )}
              </Grid.Row>
            </Grid>
            {
              hasCBMAYes
              ? <Grid padded className='nopadcol blk2 extra-fees' columns='equal'>
                <Grid.Row className='merged hts-row last-row prod-hist-display' style={{ padding: '2px' }}>
                  <Grid.Column width='4'>
                    <InputField
                      isLabel={false}
                      id={`${lineItemIndex}foreignProducerIdentifier`}
                      errors={
                        fieldValidation?.validObjects_bl[
                          `Merchandiseqwqr${'foreignProducerIdentifier'}${merchandiseId}`
                        ]
                      }
                      maxlength={14}
                      disabled={isDisabled('cbma')}
                      type={'text'}
                      className={
                        'field-bg'
                      }
                      label={'FOREIGN PRODUCER TTB ID'}
                      labelIcon={<PopUpIcon icon='info circle' popupText={'TTB ID is of the format TTB-FP-XXXXXXX where X are alphanumerics excluding O and I.'} />}
                      value={cbmaDeclarationDetails.cbmaDeclarationDetail.foreignProducerIdentifier || ""}
                      onChange={value => {
                        updateCbmaDeclarationDetail("foreignProducerIdentifier", (value||"").toUpperCase())
                      }}
                      onBlur={value => {
                        saveImporterAdditionalDeclarationDetails()
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column width='3'>
                    <InputField
                      isLabel={false}
                      id={`${lineItemIndex}foreignProducerName`}
                      errors={
                        fieldValidation?.validObjects_bl[
                          `Merchandiseqwqr${'foreignProducerName'}${merchandiseId}`
                        ]
                      }
                      disabled={isDisabled('cbma')}
                      type={'text'}
                      className={
                        'field-bg'
                      }
                      maxlength={21}
                      label={'FOREIGN PRODUCER NAME'}
                      value={cbmaDeclarationDetails.cbmaDeclarationDetail.foreignProducerName || ""}
                      onChange={value => {
                        updateCbmaDeclarationDetail("foreignProducerName", value)
                      }}
                      onBlur={value => {
                        saveImporterAdditionalDeclarationDetails()
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column width='2'>
                    <InputField
                      isLabel={false}
                      id={`${lineItemIndex}rateCode`}
                      errors={
                        fieldValidation?.validObjects_bl[
                          `Merchandiseqwqr${'rateCode'}${merchandiseId}`
                        ]
                      }
                      disabled={isDisabled('cbma')}
                      type={'text'}
                      className={
                        'field-bg'
                      }
                      label={'RATE CODE'}
                      labelIcon={<PopUpIcon 
                        icon='info circle' 
                        pinned={true} 
                        hoverable={true} 
                        popupText={
                          <>
                            Rate Code is an alphanumeric of length 6. See 'CBMA Rate Designation Code' column on the <a href="https://www.cbp.gov/trade/program-administration/entry-summary/cbma-2017/ace-cbma-tax-rates-table" target="_blank" rel="noopener noreferrer">ACE CBMA Tax Rates Table</a>.
                          </>
                        }/>}
                      value={cbmaDeclarationDetails.cbmaDeclarationDetail.rateCode || ""}
                      onChange={value => {
                        updateCbmaDeclarationDetail("rateCode", value)
                      }}
                      onBlur={value => {
                        saveImporterAdditionalDeclarationDetails()
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column width='2'>
                    <InputField
                      isLabel={false}
                      id={`${lineItemIndex}taxRate`}
                      errors={
                        fieldValidation?.validObjects_bl[
                          `Merchandiseqwqr${'taxRate'}${merchandiseId}`
                        ]
                      }
                      disabled={isDisabled('cbma')}
                      type={'text'}
                      className={
                        'field-bg'
                      }
                      label={'TTB TAX RATE'}
                      value={cbmaDeclarationDetails.cbmaDeclarationDetail.taxRate || ""}
                      onChange={value => {
                        updateCbmaDeclarationDetail("taxRate", value)
                      }}
                      onBlur={value => {
                        saveImporterAdditionalDeclarationDetails()
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column width='5'>
                    <div className='sixteen wide field floating-select borderEnd forcehasBorder' style={{padding: "10px"}}>
                      <div style={{display: "flex", fontSize: "10px"}}>
                        <CustomCheckbox
                          id={`${lineItemIndex}CBMA_CLAIM`}
                          className='cbma-declaration nolabelwrap'
                          label={"FLAVOR CONTENT CREDIT"}
                          value={cbmaDeclarationDetails.cbmaDeclarationDetail.flavorContentCredit === "Y"}
                          disabled={
                            this.state.enableLineItem === true
                              ? false
                              : Boolean(formDisabled)
                          }
                          update={value => {
                            const updatedValue = cbmaDeclarationDetails.cbmaDeclarationDetail.flavorContentCredit === "Y" ? "" : "Y"
                            updateCbmaDeclarationDetail("flavorContentCredit", updatedValue)
                            saveImporterAdditionalDeclarationDetails()
                          }}
                        />
                        <PopUpIcon icon='info circle' popupText={'An indication that the Importer is using an eligible flavor content \'credit\'. Use when depositing tax on imported distilled spirits at an effective tax rate based on eligible wine and/or flavor content.'} />
                      </div>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              : null
            }
            {
              softwoodLumberFeeDetails && softwoodLumberFeeDetails.softwoodLumberDetail.declaration != "_BLANK_"
              ? <div style={{marginBottom: "5px"}}>
                  <Grid padded className='pga-container' columns='equal' style={{ padding: '5px 5px 0 5px'}}>
                    <Grid.Row className='merged hts-row prod-hist-display' style={{ padding: '5px'}}>
                      <Grid.Column>
                        <span style={{fontSize: "11px", fontWeight: "600", padding: "0 0 10px 0"}}>
                          SOFTWOOD LUMBER DECLARATION <PopUpIcon icon='info circle' popupText={'Yes is an indication that, to the best of the Importer\'s knowledge, the information provided meets the requirements of the Softwood Lumber Act of 2008. No is an indication that the information provided does not meet the requirements of the Softwood Lumber Act of 2008.'} />
                        </span>
                        <br/>
                        <Radio
                          label='Yes'
                          name='radioGroup'
                          value='Y'
                          checked={softwoodLumberFeeDetails.softwoodLumberDetail.declaration === "Y"}
                          onChange={() => updateSoftwoodLumberDetail("declaration", "Y")}
                        />
                        <Radio
                          label='No'
                          name='radioGroup'
                          value='N'
                          checked={softwoodLumberFeeDetails.softwoodLumberDetail.declaration === "N"}
                          onChange={() => updateSoftwoodLumberDetail("declaration", "N")}
                        />
                      </Grid.Column>
                      <Grid.Column className={'borderStart'}>
                        <InputField
                          isLabel={false}
                          id={`${lineItemIndex}exportPrice`}
                          errors={
                            fieldValidation?.validObjects_bl[
                              `Merchandiseqwqr${'exportPrice'}${merchandiseId}`
                            ]
                          }
                          disabled={isDisabled('softwood')}
                          type={'text'}
                          className={'field-bg'}
                          label={'EXPORT PRICE'}
                          subLabelText=" $"
                          subLabelClass="left-icon"
                          labelIcon={<PopUpIcon icon='info circle' popupText={'The export price for the shipment of softwood lumber as defined in the legislation. Report in Whole US Dollars.'} />}
                          value={softwoodLumberFeeDetails.softwoodLumberDetail.exportPrice === "-999" ? "" : softwoodLumberFeeDetails.softwoodLumberDetail.exportPrice}
                          onChange={value => {
                            const floatingNumberRegex = /[0-9]*[.]?[0-9]*/
                            if((value.match(floatingNumberRegex)[0] === value) && value.length <= 10){
                              updateSoftwoodLumberDetail("exportPrice", value, true)
                            }
                          }}
                          onBlur={value => {
                            updateSoftwoodLumberDetail("exportPrice", value)
                          }}
                          newValue={newValue}
                          fieldName={fieldName}
                          setINPUTID={setINPUTID}
                          penClicked={penClicked}
                          shipmentId={shipmentId}
                          rbCounterID={rbCounterID}
                          clearInput={true}
                        />
                      </Grid.Column>
                      <Grid.Column className={'borderEnd no-field-margin'}>
                        <InputField
                          isLabel={false}
                          id={`${lineItemIndex}exportCharge`}
                          errors={
                            fieldValidation?.validObjects_bl[
                              `Merchandiseqwqr${'exportCharge'}${merchandiseId}`
                            ]
                          }
                          disabled={isDisabled('softwood')}
                          type={'text'}
                          className={'field-bg'}
                          label={'EXPORT CHARGE'}
                          subLabelText=" $"
                          subLabelClass="left-icon"
                          labelIcon={<PopUpIcon icon='info circle' popupText={'The tax, charge, or other fee collected by the country from which softwood lumber or a softwood lumber product, is exported persuant to an international agreement entered into by that country and the United States. Report in Whole US Dollars.'} />}
                          value={softwoodLumberFeeDetails.softwoodLumberDetail.exportCharge === "-999" ? "" : softwoodLumberFeeDetails.softwoodLumberDetail.exportCharge}
                          onChange={value => {
                            const floatingNumberRegex = /[0-9]*[.]?[0-9]*/
                            if((value.match(floatingNumberRegex)[0] === value) && value.length <= 10){
                              updateSoftwoodLumberDetail("exportCharge", value, true)
                            }
                          }}
                          onBlur={value => {
                            updateSoftwoodLumberDetail("exportCharge", value)
                          }}
                          newValue={newValue}
                          fieldName={fieldName}
                          setINPUTID={setINPUTID}
                          penClicked={penClicked}
                          shipmentId={shipmentId}
                          rbCounterID={rbCounterID}
                          clearInput={true}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
              </div>
              : null
            }
            
            {(steelSmeltAndCastDetails && steelSmeltAndCastDetails?.steelMeltAndPourCountryDetail?.countryOfMeltAndPour != "no") ?
              metalExtraDetailsScreen(steelSmeltAndCastDetails, "STEEL_MELT_AND_POUR_COUNTRY_DETAIL") :
              null}




            { (aluminumSmeltAndCastDetails && !(aluminumSmeltAndCastDetails?.aluminumSmeltAndCastCountryDetail?.doNotShowAluminum))
              ? <Grid padded className='pga-container' columns='equal' style={{ padding: '5px' }}>
                 <span style={{fontSize: "11px", fontWeight: "600", padding: "0 0 10px 0"}}>ALUMINUM SMELT AND CAST COUNTRY DETAIL</span>
                 <br/>
                 {/* <Grid.Row className='merged hts-row prod-hist-display' style={{ padding: '5px' }}>
                  <Grid.Column style={{ padding: '6px 2px' }}>
                    <>
                      <input
                        type='checkbox'
                        checked={
                          aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isUsProduct == "no" ? false : true
                        }
                        disabled={this.state.enableLineItem ? false : 
                          !formDisabled ? false :
                           isDisabled('aluminiumSmeltAndCast')
                        }    
                        style={{margin: "3px"}}
                        onChange={(e) => {
                          const updatedValue = aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isUsProduct == "no" ? "yes" : "no"
                          changeAluminumSmeltAndCastDetails("isUsProduct", updatedValue)
                        }}
                      />{' '}
                      This is a US Product
                    </>
                  </Grid.Column>
                 </Grid.Row> */}
                 <Grid.Row className='merged hts-row prod-hist-display' style={{ padding: '5px' }}>
                  <Grid.Column className={'borderStart noRightBorders'}>
                  <UpdateTariffs invoiceId={invoiceId} merchandiseId={merchandiseId}>
                    {({updateHTS})=><DropDown
                      disabled={
                        (formDisabled || aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isPrimaryCountryOfSmeltApplied == "no")
                          ? true
                          : isDisabled('aluminiumSmeltAndCast')
                      }
                      id='exclusion-dropdown-primary'
                      direction='left'
                      className={'field-bg dropdown100'}
                      isLabel={false}
                      label={
                        <>
                        PRIMARY COUNTRY OF SMELT <PopUpIcon icon='info circle' popupText={'Report the country where the largest volume of new aluminum metal is produced from alumina (or aluminum oxide) by the electrolytic Hall-Héroult process.'} />&nbsp;
                        <React.Fragment>
                          <>
                            <input
                              type='checkbox'
                              checked={
                                aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isPrimaryCountryOfSmeltApplied == "yes" ? false : true
                              }
                              disabled={this.state.enableLineItem ? false : 
                                !formDisabled ? false :
                                 isDisabled('aluminiumSmeltAndCast')
                              }    
                              // disabled={aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isUsProduct == "yes" || (aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.primaryCountryOfSmelt != "N/A" && aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.primaryCountryOfSmelt.length > 0)}                              
                              style={{margin: "3px"}}
                              onChange={(e) => {
                                const updatedValue = aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isPrimaryCountryOfSmeltApplied == "no" ? "yes" : "no"
                                changeAluminumSmeltAndCastDetails("isPrimaryCountryOfSmeltApplied", updatedValue)
                              }}
                            />{' '}
                            Does not apply
                          </>
                        </React.Fragment>
                        </>
                      }
                      text={displayDropDownItem(aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.primaryCountryOfSmelt === "N/A" ? "" : aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.primaryCountryOfSmelt, countryList)}
                      data={countryList}
                      onChange={(value) => {
                        updateHTS({countryOfSmelt:  value});
                        changeAluminumSmeltAndCastDetails("primaryCountryOfSmelt", value)
                      }}
                      errors={fieldValidation?.validObjects_bl[
                        `Merchandiseqwqr${'primaryCountryOfSmelt'}${merchandiseId}`
                      ]}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />}
                    </UpdateTariffs>
                    {/* <i aria-hidden="true" class="dropdown icon" style={{"position": "absolute", "right": "4px", "top": "8px", "opacity": "0.3"}}></i> */}
                  </Grid.Column>
                  <Grid.Column className="no-field-margin noRightBorders">
                    <DropDown
                      disabled={
                        aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isSecondCountryOfSmeltApplied == "no" ||
                        (formDisabled
                          ? true
                          : isDisabled('aluminiumSmeltAndCast')
                          )
                      }
                      id='exclusion-dropdown-secondary'
                      direction='left'
                      className={'field-bg dropdown100'}
                      isLabel={false}
                      label={
                        <>
                        SECONDARY COUNTRY OF SMELT <PopUpIcon icon='info circle' popupText={'Report the country where the second largest volume of new aluminum metal is produced from alumina (or aluminum oxide) by the electrolytic Hall-Héroult process.'} />&nbsp;
                        <React.Fragment>
                          <>
                            <input
                              type='checkbox'
                              checked={
                                aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isSecondCountryOfSmeltApplied == "yes" ? false : true
                              }
                              disabled={this.state.enableLineItem ? false : 
                                !formDisabled ? false :
                                 isDisabled('aluminiumSmeltAndCast')
                              }    
                              // disabled={aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isUsProduct == "yes" || (aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.secondaryCountryOfSmelt != "N/A" && aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.secondaryCountryOfSmelt.length > 0)}
                              style={{margin: "3px"}}
                              onChange={(e) => {
                                const updatedValue = aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isSecondCountryOfSmeltApplied == "no" ? "yes" : "no"
                                changeAluminumSmeltAndCastDetails("isSecondCountryOfSmeltApplied", updatedValue)
                              }}
                            />{' '}
                            Does not apply
                          </>
                        </React.Fragment>
                        </>
                      }
                      text={displayDropDownItem(aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.secondaryCountryOfSmelt === "N/A" ? "" : aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.secondaryCountryOfSmelt, countryList)}
                      data={countryList}
                      onChange={(value) => {
                        changeAluminumSmeltAndCastDetails("secondaryCountryOfSmelt", value)
                      }}
                      errors={fieldValidation?.validObjects_bl[
                        `Merchandiseqwqr${'secondaryCountryOfSmelt'}${merchandiseId}`
                      ]}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                    {/* <i aria-hidden="true" class="dropdown icon" style={{"position": "absolute", "right": "4px", "top": "8px", "opacity": "0.3"}}></i> */}
                  </Grid.Column>
                  <Grid.Column className={'borderEnd'}>
                    <UpdateTariffs  invoiceId={invoiceId} merchandiseId={merchandiseId}>
                    {({updateHTS})=><DropDown
                      disabled={aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isUsProduct == "yes" || (
                        this.state.enableLineItem ? false : 
                        !formDisabled ? false :
                               isDisabled('aluminiumSmeltAndCast')
                               )}
                      id='exclusion-dropdown'
                      direction='left'
                      className={'field-bg dropdown100'}
                      isLabel={false}
                      labelIcon={<PopUpIcon icon='info circle' popupText={'Report the country where the aluminum (with or without alloying elements) was last liquified by heat and cast into a solid state. The final solid state can take the form of either a semi-finished product (slab, billets or ingots) or a finished aluminum product.'} />}
                      label='COUNTRY OF CAST'
                      text={displayDropDownItem(aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.countryOfCast === "N/A" ? "" : aluminumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.countryOfCast, countryList)}
                      data={countryList}
                      onChange={(value) => {
                        updateHTS({countryOfCast:  value});
                        changeAluminumSmeltAndCastDetails("countryOfCast", value)
                      }}
                      errors={fieldValidation?.validObjects_bl[
                        `Merchandiseqwqr${'countryOfCast'}${merchandiseId}`
                      ]}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />}
                    </UpdateTariffs>
                  </Grid.Column>
                 </Grid.Row>
              </Grid>
              : null
            }
            {/* END USER FEES */}

            {this.props.launchFrom !== 'PRODUCT_HISTORY' &&
              (this.state.isPermitDtlAdded || permitTypeCode) && (
                <Grid
                  padded
                  className='nopadcol blk2 extra-fees'
                  columns='equal'
                >
                  <Grid.Row stretched className='merged hts-row'>
                    <i
                      style={{ top: '10px' }}
                      className={'trash alternate outline icon'+(isDisabled('permitTypeEnabled')?" disabled ":" ")}
                      onClick={() => {
                        if (formDisabled || isDisabled('permitTypeEnabled')) {
                          return
                        }
                        this.state.isPermitDtlAdded = false
                        updateMerchLineItemFeild(
                          lineItemIndex,
                          invoiceItemIndex,
                          'permitTypeCode',
                          'NONE_PERMIT_TYPE_CODE'
                        )
                        updateMerchLineItemFeild(
                          lineItemIndex,
                          invoiceItemIndex,
                          'permitNumber',
                          '_BLANK_'
                        )
                        saveDescriptionOfMerchandiseLine(
                          lineItemIndex,
                          invoiceItemIndex,
                          'permitNumber',
                          '_BLANK_'
                        )
                        saveDescriptionOfMerchandiseLine(
                          lineItemIndex,
                          invoiceItemIndex,
                          'permitTypeCode',
                          'NONE_PERMIT_TYPE_CODE'
                        )
                        clearDescriptionOfMerchandiseLine(
                          lineItemIndex,
                          invoiceItemIndex,
                          'permitTypeCode'
                        )
                      }}
                    />
                    <Grid.Column className={'borderStart'}>
                      <DropDown
                        disabled={
                          this.state.enableLineItem === true
                            ? false
                            : isDisabled('permitTypeEnabled')
                        }
                        id={`${lineItemIndex}permitTypeCode`}
                        label='PERMIT/CERTIFICATE/LICENSE TYPE'
                        className='field-bg dropdown100'
                        isLabel={false}
                        text={displayDropDownItem(
                          permitTypeCode,
                          permitTypeCodesList
                        )}
                        data={permitTypeCodesList}
                        onChange={(value) => {
                          updateMerchLineItemFeild(
                            lineItemIndex,
                            invoiceItemIndex,
                            'permitTypeCode',
                            value
                          )
                          handleLineItemContextSwitch(
                            lineItemIndex,
                            invoiceItemIndex
                          )
                          saveDescriptionOfMerchandiseLine(
                            lineItemIndex,
                            invoiceItemIndex,
                            'permitTypeCode',
                            value
                          )
                        }}
                        errors={permitTypeCode ? [] : ['Missing permit type code']}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    <Grid.Column className={`${permitTypeCode && typeof permitTypeCode === 'string'?'':'borderEnd'} permit-number`}>
                      <InputField
                        // merchandiseId={data[index] ? data[index].merchandiseId : ''}
                        isLabel={false}
                        id={`${lineItemIndex}permitNumber`}
                        errors={
                          fieldValidation?.validObjects_bl[
                            `Merchandiseqwqr${'permitNumber'}${merchandiseId}`
                          ]
                        }
                        disabled={
                          this.state.enableLineItem === true
                            ? false
                            : isDisabled('permitTypeEnabled')
                        }
                        type={'text'}
                        className={'field-bg'}
                        label={'PERMIT/CERTIFICATE/LICENSE NUMBER'}
                        placeholder={'PERMIT/CERTIFICATE/LICENSE NUMBER'}
                        value={permitNumber}
                        maxlength={9}
                        onChange={(value) => {
                          if(!value)value="_BLANK_"
                          updateMerchLineItemFeild(
                            lineItemIndex,
                            invoiceItemIndex,
                            'permitNumber',
                            value
                          )
                        }}
                        onBlur={(value) => {
                          saveDescriptionOfMerchandiseLine(
                            lineItemIndex,
                            invoiceItemIndex,
                            'permitNumber'
                          )
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                        clearInput={true}
                      />
                    </Grid.Column>
                    {permitTypeCode &&
                      typeof permitTypeCode === 'string' &&
                      permitTypeCode.toUpperCase().includes('STEEL') &&
                      steelExclusionGenericExclusion(
                        countryOfOrigin == 'KR'
                          ? [
                              'PRODUCT_EXCLUSION_INFORMATION_STEEL_PRODUCTS',
                              'SOUTH_KOREAN_EXPORT_STEEL_CERTIFICATE',
                            ]
                          : ['PRODUCT_EXCLUSION_INFORMATION_STEEL_PRODUCTS'],
                        'STEEL EXCLUSION/EXPORT CERTIFICATE',
                        {
                          PRODUCT_EXCLUSION_INFORMATION_STEEL_PRODUCTS: {
                            validationShortExplanation:
                              'Must be SPR,STL,STX followed by 6 numbers',
                            validationExplanation: (
                              <div>
                                Three common formats issued by the U.S.
                                Department of Commerce are as follows:
                                <h5>
                                  <b>Format 'STLnnnnnn'</b>
                                </h5>
                                Where 'nnnnnn' represents the Regulations.gov
                                docket number for product exclusion, with no
                                spaces or special characters.
                                <h5>
                                  <b>Format 'SPRnnnnnn' or 'STXnnnnnn'</b>
                                </h5>
                                Where 'nnnnnn' represents the exclusion request
                                ID obtained from the DOC/BIS 232 Exclusions
                                Portal. The obtained Exclusion Request ID should
                                be prefaced with leading zeroes
                                <br />
                                E.G. <b>165 becomes SPR000165</b>
                              </div>
                            ),
                            validationRegex: /((STL)|(SPR)|(STX))[\d]{6}/i,
                          },
                        }
                      )}


                      {permitTypeCode &&
                        typeof permitTypeCode === 'string' &&
                        permitTypeCode.toUpperCase().includes('ALUMINUM') &&
                        steelExclusionGenericExclusion(
                          ['PRODUCT_EXCLUSION_INFORMATION_ALUMINUM_PRODUCTS'],
                          'ALUMINUM EXCLUSION',
                          {
                            PRODUCT_EXCLUSION_INFORMATION_ALUMINUM_PRODUCTS: {
                              validationShortExplanation:
                                'Must be ALU or APR followed by 6 numbers. Ignore this error if "Other Formats"',
                              validationExplanation: (
                                <div>
                                  Two common formats issued by the U.S.
                                  Department of Commerce are as follows:
                                  <h5>
                                    <b>Format 'ALUnnnnnn'</b>
                                  </h5>
                                  Where 'nnnnnn' represents the Regulations.gov
                                  docket number for product exclusion, with no
                                  spaces or special characters.
                                  <h5>
                                    <b>Format 'APRnnnnnn'</b>
                                  </h5>Where ‘nnnnnn’ represent the Exclusion 
                                  Request ID obtained from the DOC/BIS 232 Exclusions Portal.
                                   The obtained Exclusion Request ID should be prefaced with leading
                                    zeros (‘0’) not to exceed a numeral length of six. 
                                    E.g., ‘165’ becomes ‘APR000165’.
                                  <br />
                                  
                                  <h5>
                                  <b>Other formats (not specified here)</b> may be issued to address a court order or injunction.
                                  </h5>

                                </div>
                              ),
                              validationRegex: /[a-zA-Z0-9]{9}/i,
                            },
                          }
                        )}
                  </Grid.Row>
                </Grid>
              )}
            {this.props.launchFrom !== 'PRODUCT_HISTORY' &&
              !(this.state.isPermitDtlAdded || permitTypeCode) && ( this.state.enableLineItem  || !isDisabled('permitTypeEnabled') ) && (
                <Grid.Row>
                  <Grid.Column className='no-field-margin'>
                    <a
                      style={{
                        color: '#1a69a4',
                        cursor: 'pointer',
                        marginLeft: '5px',
                      }}
                      onClick={() => {
                        this.setState({
                          isPermitDtlAdded: true,
                        })
                      }}
                      disabled={
                        formDisabled ||
                        (this.state.enableLineItem === true
                          ? false
                          : Boolean(
                              this.state.isPermitDtlAdded || permitTypeCode
                            ))
                      }
                    >
                      {this.props.launchFrom !== 'PRODUCT_HISTORY' && (
                        <span>
                          <Icon name='add circle' disabled={formDisabled} /> Add
                          Permit/Certificate/License Details
                        </span>
                      )}
                    </a>
                  </Grid.Column>
                </Grid.Row>
              )}
               {this.props.launchFrom !== 'PRODUCT_HISTORY' &&
                <AdditionalDeclarations
                  disabledState={isDisabled('additionalDeclarations')}
                  addDeclarations={addDeclarations}
                  deleteDeclarations={deleteDeclarations}
                    declarations={(importerAdditionalDeclarationDetails?.importerAdditionalDeclarationDetail|| [])?.filter(
                      (declaration) =>
                        DECLARATION_OPTIONS.some(
                          (option) => option.typeCode === declaration.typeCode
                        )
                    ).map((item)=> item.typeCode
                    )}
                  shipmentId={shipmentId}
                  invoiceId={invoiceId}
                  invoiceItemIndex={invoiceItemIndex}
                  lineItemIndex={lineItemIndex}
                  merchandiseId={merchandiseId}
                  formDisabled={formDisabled}
                />
              }
            {this.props.launchFrom !== 'PRODUCT_HISTORY' && (
              (!(this.state.isAdministrativeRulingAdded || hasRulingNumber))  ? 
              ( this.state.enableLineItem  || !isDisabled('permitTypeEnabled') )&& <Grid
                padded
                className='nopadcol blk2 extra-fees'
                columns='equal'
              >
                <Grid.Row>
                  <Grid.Column className='no-field-margin'>
                    <a
                      style={{
                        color: '#1a69a4',
                        cursor: 'pointer',
                        marginLeft: '5px',
                      }}
                      onClick={() => {
                        this.setState({
                          isAdministrativeRulingAdded: true,
                        })
                      }}
                      disabled={
                        formDisabled ||
                        (this.state.enableLineItem === true
                          ? false
                          : Boolean(
                              this.state.isAdministrativeRulingAdded || hasRulingNumber
                            ))
                      }
                    >
                      {this.props.launchFrom !== 'PRODUCT_HISTORY' && (
                        <span>
                          <Icon name='add circle' disabled={formDisabled} /> Add
                            Administrative Ruling
                        </span>
                      )}
                    </a>
                </Grid.Column>
              </Grid.Row>
              </Grid>
              :
              <Grid
                padded
                className='nopadcol blk2 extra-fees'
                columns='equal'
              >

                <Grid.Row className="row merged hts-row prod-hist-display finalRowz">
                  <Grid.Column style={{flex:'0.1',padding: ".7rem",paddingRight:"0px"}}>
                          <span>
                            <Icon name='trash alternate outline' 
                            
                      onClick={(value) => {
                        let newAdministrativeRulingObject = {
                          rulingNumber: '_BLANK_',
                          rulingType: '_BLANK_',
                        }
                        updateMerchLineItemFeild(
                          lineItemIndex,
                          invoiceItemIndex,
                          'administrativeRuling',
                          newAdministrativeRulingObject
                        )
                        saveDescriptionOfMerchandiseLine(
                          lineItemIndex,
                          invoiceItemIndex,
                          'administrativeRuling',
                          newAdministrativeRulingObject
                        );
                        this.setState({
                          isAdministrativeRulingAdded: false,
                        })
                      }}
                            />
                            {/* <!-- text goes here-- */}
                          </span>
                  </Grid.Column>
                  <Grid.Column className={'borderStart'}>
                    <DropDown
                      disabled={
                        this.state.enableLineItem === true
                          ? false
                          : isDisabled('permitTypeEnabled')
                      }
                      id={`${lineItemIndex}administrativeRuling.rulingType`}
                      label='Ruling Type'
                      className='field-bg dropdown100'
                      isLabel={false}
                      
                      text={displayDropDownItem(
                        administrativeRuling?.rulingType,
                        administrativeRulingTypeList
                      )}
                      data={administrativeRulingTypeList}
                      onChange={(value) => {
                        let newAdministrativeRulingObject= {
                          ...administrativeRuling,
                          rulingType: value
                        }
                        updateMerchLineItemFeild(
                          lineItemIndex,
                          invoiceItemIndex,
                          'administrativeRuling',
                          newAdministrativeRulingObject
                        )
                        saveDescriptionOfMerchandiseLine(
                          lineItemIndex,
                          invoiceItemIndex,
                          'administrativeRuling',
                          newAdministrativeRulingObject
                        )
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column  className={`borderEnd permit-number`}>
                    <InputField
                      // merchandiseId={data[index] ? data[index].merchandiseId : ''}
                      isLabel={false}
                      id={`${lineItemIndex}administrativeRuling.rulingNumber`}
                      errors={
                        fieldValidation?.validObjects_bl[
                        `Merchandiseqwqr${'administrativeRuling.rulingNumber'}${merchandiseId}`
                        ]
                      }
                      disabled={
                        this.state.enableLineItem === true
                          ? false
                          : isDisabled('permitTypeEnabled')
                      }
                      type={'text'}
                      className={'field-bg'}
                      label={"RULING NUMBER"}
                      placeholder={'RULING NUMBER'}
                      value={administrativeRuling?.rulingNumber}
                      onChange={(value) => {
                        if (!value) value = "_BLANK_"
                        let newAdministrativeRulingObject= {
                          ...administrativeRuling,
                          rulingNumber: value
                        }
                        updateMerchLineItemFeild(
                          lineItemIndex,
                          invoiceItemIndex,
                          'administrativeRuling',
                          newAdministrativeRulingObject
                        )
                      }}
                      onBlur={(value) => {
                        saveDescriptionOfMerchandiseLine(
                          lineItemIndex,
                          invoiceItemIndex,
                          'administrativeRuling'
                        )
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                  </Grid.Column>
                </Grid.Row>
                </Grid>
            )}


            {!!(this.props.launchFrom !== 'PRODUCT_HISTORY' && showManualAddAdcvdButton) && (

              <Grid.Row>
                <Grid.Column className='no-field-margin'>
                  <a
                    style={{
                      color: '#1a69a4',
                      cursor: 'pointer',
                      marginLeft: '5px',
                    }}
                    onClick={() => {
                      this.setState({
                        manualAdcvdButtonClicked: true,
                        manualAdcvdButtonClickedThisSession: true,
                      })
                    }}
                    disabled={
                      this.state.enableLineItem === true
                        ? false
                        : isDisabled('voluntaryAdcvdSectionEnabled', Boolean(formDisabled))
                    }
                  >
                    <span>
                      <Icon name='add circle' disabled={formDisabled} />
                      &nbsp;Add Voluntary AD/CVD
                    </span>
                  </a>
                </Grid.Column>
              </Grid.Row>
            )}
            {showAdcvdSection && (
              <Grid.Row className='noDisplayFlexPlease'>
                <Grid.Column className='no-field-margin'>
                  <AVCVDSection
                    launchFrom={this.props.launchFrom}
                    updateFormState={this.props.updateFormState}
                    lineItemIndex={lineItemIndex}
                    invoiceItemIndex={invoiceItemIndex}
                    merchandiseId={merchandiseId}
                    mystate={this.state.mystate}
                    brokerId={this.state.brokerId}
                    formDisabled={
                      this.state.enableLineItem === true ? 
                        false :

                       isDisabled(voluntaryAdcvdAdd?'voluntaryAdcvdSectionEnabled':"adcvdSectionEnabled",formDisabled)
                    }
                    shipmentId={this.props.shipmentId}
                    adcvd={this.props.adcvd}
                    voluntaryAdcvdAdd={voluntaryAdcvdAdd}
                    manualAdcvdButtonClickedThisSession={manualAdcvdButtonClickedThisSession}
                    voluntaryAdcvdClear={()=>{
                      this.setState({
                        manualAdcvdButtonClicked: false,
                        manualAdcvdButtonClickedThisSession: false,
                      });
                    }}
                    validateFormzz={this.props.validateFormzz}
                  ></AVCVDSection>
                </Grid.Column>
              </Grid.Row>
            )}
            {isWarehouseEntry(this.props.EntryTypeInfo) ?<>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <div className="dashedContainer" style={{marginBottom:'5px'}} >
              Warehouse. No PGA Data. 
              </div>
            </>:(updateType=="entryUpdate" && (isDisabled("pgasAreEnabled_m",formDisabled) && !formDisabled && !this.state.showPgasAnyway))?
            <>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <div className="dashedContainer" style={{marginBottom:'5px'}} >
              Entry Summary Only. No PGA Data during an entry summary update. 
              </div>
            </>:
            this.state.doingHistoryStuff?"History Working...":
            <><Grid.Row style={{flexDirection:'row-reverse',height:'15px'}} >
              <Grid.Column width='9'>
                </Grid.Column>
              {!!allPgaListForDropdown.length && (htsus?.length >=8) && !Boolean(formDisabled) &&<Grid.Column width='3' style={{minWidth:'200px',position:'relative',top:showManualAddAdcvdButton?'-20px':'-5px' }}>
                <DropDown
                  disabled={(this.state.addingVoluntary||0>Date.now()) ||
                    _.get(this.props, 'pscData.pscShipmentId') ||
                     isDisabled("pgasAreEnabled_m",formDisabled)}
                  label={(this.state.addingVoluntary||0>Date.now())? `... adding ${pgaLabels[this.state.addingVoluntaryName] || this.state.addingVoluntaryName}` :
                    _.get(this.props, 'pscData.pscShipmentId')?'PSC Shipment, no PGAs':'+ Add voluntary PGA'}
                  key={this.state.allowReselectionOfPGA+"xxxx"+merchandiseId}
                  style={{ }}
                  placeholder='+ Add voluntary PGA'
                  noTextDisplay={true}
                  id={shipmentId+"addpgayes"}
                  value="          "
                  data={allPgaListForDropdown}
                  className='field-bg dropdown100 minisize'
                  shipmentId={shipmentId}
                  onChange={value => {
                    let timeout = 3000;
                    this.setState({addingVoluntary:new Date()+timeout})
                    setTimeout(()=>{
                      this.setState({addingVoluntary:0});
                    },timeout+100);
                    this.setState({addingVoluntaryName:value})
                    this.setState({allowReselectionOfPGA:Math.random()})
                    createNewPgaSelection(value,true)
                  }}
                />
              </Grid.Column>}
            </Grid.Row>
            <input id={`${merchandiseId}addnewPgaInput`} type="hidden" onClick={()=>{
              createNewPgaSelection(window[merchandiseId+"addnewPgaInput"].pgaType,window[merchandiseId+"addnewPgaInput"].manuallyAddedPage,window[merchandiseId+"addnewPgaInput"].myoldxPga)
            }} />
            {(articleHeader !== 'X' && this.props.launchFrom != 'PRODUCT_HISTORY'/*history shows pgas separately*/ &&
              !_.get(this.props, 'pscData.pscShipmentId') ) ? (
                <Grid.Row className='noDisplayFlexPlease'>
                  <Grid.Column className='no-field-margin'>
                    <PGAItems
                      launchFrom={this.props.launchFrom}
                      entryTypeInfo={this.props.EntryTypeInfo}
                      countryOfOrigin={countryOfOrigin}
                      createPGA={createPGA}
                      formDisabled={
                        this.state.enableLineItem === true
                          ? false
                          : isDisabled("pgasAreEnabled_m",formDisabled)
                      }
                      lineItemIndex={lineItemIndex}
                      merchandiseId={merchandiseId}
                      createNewPgaSelection={createNewPgaSelection}
                      invoiceItemIndex={invoiceItemIndex}
                      hsDataDtl_paramy={hsDataDtl}
                      modeOfTransport={this.props.modeOfTransport}
                      updateMerchLineItemPgaObject={
                        updateMerchLineItemPgaObject
                      }
                      prodHistoryFormData={this.props.prodHistoryFormData}
                      currentJobData={this.props.currentJobData}
                    />
                  </Grid.Column>
                </Grid.Row>
              ):<><br/><br/></>}
              </>/*end disabled if es updated*/}
          </>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  if (props.launchFrom === 'PRODUCT_HISTORY') {
    return {
      // countryList: state.DropDownValues.countryList,
      // userFeeCodes: state.DropDownValues.userFeeCodes,
      // permitTypeCodesList: state.DropDownValues.permitTypeCodesList,
      // USStatesList: state.DropDownValues.USStatesList,
      // splProgramList: state.DropDownValues.splProgramList,
    }
  }
  return {
    invoiceItemIndex: props.invoiceItemIndex,
    invoiceId:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ]?.invoiceId,
    thisMerchandiseItem: state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex],
    lineItemIndex: props.lineItemIndex,
    allVoluntaryPGAs: state.DropDownValues.allVoluntaryPGAs,
    itDate: state.BOLInfo?.itDate?.epochs,
    entryDate: state.EntryTypeInfo?.summaryDate?.epochs,
    htsus:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].htsus,
    tfdIndicator: state.DescriptionOfMerchandise.entrySummaryInvoices[
      props.invoiceItemIndex
    ].merchandiseLineItems[props.lineItemIndex]?.tfdIndicator,
    partRefreshFlag: state.DescriptionOfMerchandise.entrySummaryInvoices[
      props.invoiceItemIndex
    ].merchandiseLineItems[props.lineItemIndex]?.partRefreshFlag,
    htsDescription:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0]
        .htsDescription,
    merchandiseDuties:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties,
    commercialDescription:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].commercialDescription,
    productTag:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].productTag,
    countryOfOrigin:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].countryOfOrigin,
    permitTypeCode:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].permitTypeCode,
    permitNumber:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].permitNumber,
    administrativeRuling:
    state.DescriptionOfMerchandise.entrySummaryInvoices[
      props.invoiceItemIndex
    ].merchandiseLineItems[props.lineItemIndex].administrativeRuling,
    importerAdditionalDeclarationDetails:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex]
        .importerAdditionalDeclarationDetails,
    productClaimCode:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].productClaimCode,
    countryList: state.DropDownValues.countryList,
    userFeeCodes: state.DropDownValues.userFeeCodes,
    permitTypeCodesList: state.DropDownValues.permitTypeCodesList,
    pgaFlagInfos: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].pgaFlagInfos || [],
  
    importerAdditionalDeclarationTypeCodesList:
      state.DropDownValues.importerAdditionalDeclarationTypeCodesList,
    USStatesList: state.DropDownValues.USStatesList,
    internalRevenueAccountingClassCodesList:
      state.DropDownValues.internalRevenueAccountingClassCodesList,
    splProgramList: state.DropDownValues.splProgramList,
    cbpSeqNo:state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]?.cbpSeqNo,
    hsDataDtl:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0]
        .hsDataDtl,
    merchandiseId:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseId,
    isAdCvdApplicable:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0]
        ?.hsDataDtl?.adCvdApplicable,
    mpfFee:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].mpf.fee,
    hmfFee:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].hmf.fee,
    adcvd:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].adcvd,
    IRTax:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ]?.merchandiseLineItems[props.lineItemIndex]?.merchandiseDuties[0]?.IRTax,
    allDuties:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties,
    irInfo:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ]?.merchandiseLineItems[props.lineItemIndex]?.merchandiseDuties[0]
        ?.irInfo || {},
    charges:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].charges,
    otherFee:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].otherFee,
    userFees:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0]
        .additionalDuties.userFees,
    manufacturerHeaderIdUnderPartiesTab:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex]
        .manufacturerHeaderIdUnderPartiesTab,
    weightUnitsList: state.DropDownValues.weightUnitsList,
    EntryTypeInfo: state.EntryTypeInfo,
    grossWeightWeight:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].grossWeight.weight,
    allsequenceNumberSorted: (_.flatten((state.DescriptionOfMerchandise.entrySummaryInvoices||[]).map(a=>a?.merchandiseLineItems))||[]).map(a=>a?.seqNo).sort((a,b)=>a-b), 
    invoiceCurrencyValue:
    state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
      .merchandiseDuties[0].invoiceCurrencyValue || "",
    grossWeightUnits:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex].grossWeight.weightUnits,
    availableProductClaimCode: _.get(
      state,
      `DescriptionOfMerchandise..entrySummaryInvoices[${props.invoiceItemIndex}].merchandiseLineItems[${props.lineItemIndex}].availableProductClaimCode`,
      []
    ),
    totalAdditions:  state.DescriptionOfMerchandise.entrySummaryInvoices[
      props.invoiceItemIndex
    ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0]
      .additions?.totalAdditions,
       totalDeletions:  state.DescriptionOfMerchandise.entrySummaryInvoices[
      props.invoiceItemIndex
    ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0]
      .deletions?.totalDeletions,
    headerParties: state.Importer.headerParties,
    unitList: state.DropDownValues.unitList,
    newValue: state.FormValues.newValue,
    fieldName: state.FormValues.fieldName,
    setINPUTID: state.FormValues.setINPUTID,
    penClicked: state.FormValues.penClicked,
    shipmentId: state.FormValues.shipmentId,
    rbCounterID: state.FormValues.rbCounterID,
    formDisabled: state.FormValues.formDisabled,
    fieldValidation: state.FieldValidation,
    pscData: state.PSC
  }
}

const mapDispatchToProps = {
  ...actionCreators,
  addDeclarations: addAdditionalDeclarations,
  deleteDeclarations: deleteAdditionalDeclarations
}

export default React.memo(
  connect(mapStateToProps, mapDispatchToProps)(MerchandiseLineItem)
)
